<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

    <v-form ref="formgelenfatura" v-model="validform" lazy-validation>
      <v-card flat color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{sayfabaslik}}  -  {{  getSaticiTip(GelenFatura.Fatura.SaticiTip)  }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip v-if="kaydetbuton" bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="Kaydet('1')" flat> <span
                    class="hidden-sm-and-down"> {{$t("save_button")}}
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>

              <v-tooltip v-if="guncellebuton" bottom>
                <v-btn v-if="guncellebuton" :disabled="!sayfayetki.Update" slot="activator" @click="Kaydet('2')" flat>
                  <span class="hidden-sm-and-down"> {{ $t('Update') }}
                  </span>
                  <v-icon color="white" right dark>create</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>

              <v-btn @click="Yazdir()" v-if="yazdirbtngoster" flat> <span class="hidden-sm-and-down"> {{ $t('Print') }} </span>
                <v-icon right dark>print</v-icon>
              </v-btn>

              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-tooltip bottom>
                    <v-list-tile v-if="guncellebuton" slot="activator" :disabled="!sayfayetki.Delete"
                      @click="faturasil()">
                      <v-list-tile-title> {{ $t('Delete-Invoice') }} </v-list-tile-title>
                    </v-list-tile>
                    <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                    <span v-if="sayfayetki.Delete"> {{ $t('Delete-Invoice') }} </span>
                  </v-tooltip>


                  <v-tooltip bottom>
                    <v-list-tile v-if="guncellebuton" slot="activator" :disabled="!sayfayetki.Update"
                      @click="faturaiade()">
                      <v-list-tile-title> {{ $t('Invoice-Return') }} </v-list-tile-title>
                    </v-list-tile>
                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                    <span v-if="sayfayetki.Update">{{ $t('Invoice-Return') }}</span>
                  </v-tooltip> 


                  <a target="_self" v-bind:href="'#/coper/page/formlar/gelenfaturalistesi'">
                    <v-list-tile>
                      <v-list-tile-title>{{ $t('List-of-Invoices-Received') }} </v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap>

              <v-flex pa-1 xs12 sm12 md4>


                <v-flex mt-2 xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>

                     
                          <v-flex xs12 sm12 md12>
                            <saticiara ref="saticiara" v-model="GelenFatura.Fatura.Satici" :tip="GelenFatura.Fatura.SaticiTip" @setSeller="setSaticiTip($event)" ></saticiara>
                            <!-- <genelarama :autofocuss="true" :rules="[v => !!v || $t('Mandatory-Areas')]"
                              v-model="GelenFatura.Fatura.Satici" apiname="SaticiAra"
                              :tip="GelenFatura.Fatura.SaticiTip" 
                              :icdis="YurtDisi"
                              :label="$t('Seller-Code')">
                            </genelarama> -->
                          </v-flex>

                          <v-flex xs12 sm6 md6>
                            <v-autocomplete :items="faturatipi" hide-details="" v-model="GelenFatura.Fatura.FaturaTip"
                              item-text="text" item-value="value" :label="$t('Invoice-Type')"></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm6 pl-2 md6>
                            <v-checkbox v-model="GelenFatura.Fatura.Proforma" label="Proforma" hide-details>
                            </v-checkbox>

                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="GelenFatura.Fatura.Aciklama" maxlength="250" hide-details="" :label="$t('Description')"
                              value="">
                            </v-text-field>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-flex>


              <v-flex pa-1 mt-2 xs12 sm6 md4>

                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-layout row wrap>

                          <v-flex xs12 sm6 md6>
                            <v-autocomplete :items="doviztipi" hide-details="" item-text="Title" item-value="DovizKod"
                              v-model="GelenFatura.Fatura.FatPara" @change="kurgetir2()" :label="$t('Invoice-Money')">
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <dovizinput v-model="GelenFatura.Fatura.FatKur" :etiket="$t('Invoice-Exchange-Rate')"
                              :autocomplete="autocomplete">
                            </dovizinput>
                          </v-flex>

                          <v-flex pt-2 xs12 sm12 md12>
                            <v-btn outline @click.native="ekstradialog=true" block color="info">  {{ $t('Extra-Details') }} 
                            </v-btn>
                          </v-flex>

                        </v-layout>

                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

              <v-flex pa-1 xs12 mt-2 sm6 md4>
                <v-flex xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>

                              <tarihcomp :etiket="$t('Invoice-Date')" :detaygizle="true"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="GelenFatura.Fatura.FatTarih" v-model="GelenFatura.Fatura.FatTarih">
                              </tarihcomp>


                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field :disabled="seridisable" :label="$t('Invoice-Serial-No-v2')" hide-details
                                    :rules="[v => !!v || $t('Mandatory-Areas'), () => !!GelenFatura.Fatura.FatSeri && GelenFatura.Fatura.FatSeri.length <= 3|| $t('Cannot-exceed-three-characterst')]"
                                    v-model="GelenFatura.Fatura.FatSeri"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field hide-details="" mask="##########" :disabled="seridisable"
                                    :label="$t('Invoice-No')" v-model="GelenFatura.Fatura.FatNo"
                                    :rules="[v => !!v || $t('Mandatory-Areas')]"></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <tarihcomp :etiket="$t('Maturity')" :detaygizle="true"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="GelenFatura.Fatura.VadeTarihi" v-model="GelenFatura.Fatura.VadeTarihi">
                              </tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <tarihcomp :etiket="$t('Invoice-Term-Date')" :detaygizle="true"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="GelenFatura.Fatura.HesaplananVade"
                                v-model="GelenFatura.Fatura.HesaplananVade"></tarihcomp>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field label='EvrakNo' hide-details
                                    v-model="GelenFatura.Fatura.EvrakNo"></v-text-field>
                                
                            </v-flex>

                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-flex>

            </v-layout>


            <v-flex mt-2 xs12 sm12 md12>
              <v-card color="grey lighten-5" flat="">
                <v-card-actions>
                  <v-layout row wrap>

                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap class=" project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title> <span class="subheading black--text">
                                   {{ $t('Sales-Items') }} 
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-btn color="grey" @click="satirekle()" flat> {{ $t('Add-Item') }} 
                                <v-icon color="grey" right dark>add_box</v-icon>
                              </v-btn>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>
                        <v-flex pl-2 v-if="GelenFatura.Fatura.Kalemler.length==0" xs12 sm12 md12>
                          <span class="grey--text "> {{ $t('Item-has-yet-to-be-added') }} </span>
                        </v-flex>

                        <v-flex v-for="item in GelenFatura.Fatura.Kalemler" pt-1 v-bind:key="item.id" xs12 sm12 md12>
                          <v-layout class=" project overdue">
                            <v-hover>
                              <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                width="100%">


                                <v-list two-line="">
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                      <v-card flat class="black--text">
                                        <v-card flat="">
                                          <v-card-actions>
                                            <v-layout row wrap>

                                              <v-flex xs12 sm4 md2>
                                                <v-layout
                                                  v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                                                  align-center justify-start fill-height>
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-layout row align-center justify-start>

                                                          <v-chip small="" color="pink" text-color="white">
                                                            <v-avatar>
                                                              <v-icon color="white">hotel</v-icon>
                                                            </v-avatar>
                                                            Coper
                                                          </v-chip>

                                                        </v-layout>

                                                        <v-list-tile-sub-title>
                                                          <div class="font-weight-bold  "> Pnr No:
                                                            {{item.PNR_No}}
                                                          </div>
                                                        </v-list-tile-sub-title>

                                                        <v-list-tile-sub-title>
                                                          <div class="font-weight-bold  "> {{ $t('Process-Ref') }} :
                                                            {{item.IslemRef}}
                                                          </div>
                                                        </v-list-tile-sub-title>

                                                       

                                                      </v-list-tile-content>
                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>

                                              </v-flex>


                                              <v-flex xs6 sm2 md2>
                                                <v-layout>
                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout align-start="" justify-start fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content style="'overflow=inherit';">

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold caption ">
                                                                {{ $t('Amount') }}
                                                              </div>
                                                            </v-list-tile-sub-title>


                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold caption ">
                                                                 {{ $t('VAT-Amount') }} :
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                            


                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout row justify-end="" fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end>
                                                                <div class="font-weight-  caption ">
                                                                  {{item.Tutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}</div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>


                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end>
                                                                <div class="font-weight-  caption ">
                                                                  {{item.KDVTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                          
                                                            <v-list-tile-sub-title>
                                                          <div > {{item.Aciklama}}
                                                          </div>
                                                        </v-list-tile-sub-title>

                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>


                                              <v-flex xs6 sm2 md2>
                                                <v-layout>
                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout align-start="" justify-start fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content style="'overflow=inherit';">

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold caption ">
                                                                 {{ $t('Deduction-Rate')  }} :
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold  caption">
                                                                {{  $t('Deduction-Amount') }}
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout row justify-end="" fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end>
                                                                <div class="font-weight-  caption ">
                                                                  {{item.TevkifatOran | orangoster}}%</div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end="">
                                                                <div class="font-weight-  caption ">
                                                                  {{item.TevkifatTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>


                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>


                                              <v-flex xs6 sm2 md2>
                                                <v-layout>
                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout align-start="" justify-start fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content style="'overflow=inherit';">

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold caption ">
                                                                 {{ $t('Withholding-Rate') }} :
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold  caption">
                                                                {{ $t('Withholding-Amount') }}
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout row justify-end="" fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content>



                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end>
                                                                <div class="font-weight-  caption ">
                                                                  {{item.StopajOran | moneyformat}}%</div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end="">
                                                                <div class="font-weight-  caption ">
                                                                  {{item.StopajTutar | moneyformat }}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>




                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 sm4 md2>
                                                <v-layout row align-center justify-center="" fill-height="">
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-layout row wrap justify-center="">
                                                          <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                              KDV'li Tutar
                                                            </v-layout>
                                                          </v-list-tile-title>
                                                          <v-list-tile-sub-title>
                                                            <v-layout row wrap justify-end="">
                                                              <div class="red--text subheading">
                                                                {{item.KDVliTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}

                                                              </div>
                                                            </v-layout>

                                                          </v-list-tile-sub-title>
                                                          <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                              <div class="font-weight green--text caption ">
                                                                % {{item.KDVYuzde | moneyformat}} {{ $t('VAT') }}
                                                              </div>
                                                            </v-layout>

                                                          </v-list-tile-title>
                                                        </v-layout>
                                                      </v-list-tile-content>

                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 sm4 md2>
                                                <v-card flat="">
                                                  <v-layout row wrap align-center="" justify-end="" fill-height="">


                                                    <v-flex xs2 sm2 md2>
                                                      <v-tooltip slot="append" bottom>
                                                        <v-btn slot="activator" icon class="mx-0"
                                                          @click="satirsil(item)">
                                                          <v-icon color="red">delete</v-icon>
                                                        </v-btn>
                                                        <span> {{ $t('Delete') }} </span>
                                                      </v-tooltip>
                                                    </v-flex>

                                                    <!-- <v-flex xs2 sm2 md2>
                                                      <v-tooltip slot="append" bottom>
                                                        <v-btn slot="activator" icon class="mx-0"
                                                          @click="satirduzenle(item)">
                                                          <v-icon color="green">edit</v-icon>
                                                        </v-btn>
                                                        <span>Düzenle</span>
                                                      </v-tooltip>
                                                    </v-flex> -->


                                                  </v-layout>

                                                </v-card>
                                              </v-flex>

                                              <!--
                                    <v-flex xs12 sm4 md2>
                                      <v-card flat="">
                                        <v-layout row wrap align-center="" justify-start="" fill-height="">




                                          <v-flex xs12 sm2 md2>
                                            <v-tooltip slot="append" bottom>
                                              <v-btn small v-if="item.GenelBilgileri.FaturaTip!='0'" slot="activator"
                                                icon class="mx-0"
                                                @click="efaturagoster(item.GenelBilgileri.EFaturaShowID.EFaturaGuid,item.GenelBilgileri.EFaturaShowID.EFaturaID)">
                                                <v-icon color="info">line_weight</v-icon>
                                              </v-btn>
                                              <span>E-Fatura</span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex xs12 sm2 md2>
                                            <v-tooltip slot="append" bottom>
                                              <v-btn small icon slot="activator" class="mx-0"
                                                @click="reportbrobas(item.GenelBilgileri.EFaturaShowID.EFaturaGuid,item.GenelBilgileri.EFaturaShowID.EFaturaID,item.GenelBilgileri.EFaturaShowID.PdfID)">
                                                <v-icon color="info">print</v-icon>
                                              </v-btn>
                                              <span>{{ $t('Print') }}</span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex
                                            v-if="(item.GenelBilgileri.FaturaTip=='1' || item.GenelBilgileri.FaturaTip=='2') &&item.GenelBilgileri.EFaturaShowID.FaturaStatus=='Fatura Beklemede'"
                                            xs12 sm2 md2>
                                            <v-tooltip bottom>
                                              <v-btn small icon :disabled="!sayfayetki.Update" slot="activator"
                                                @click="OnayaGonderTekli(item)" flat>
                                                <v-icon color="info" dark>check</v-icon>
                                              </v-btn>
                                              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}( {{ $t('Send-for-Approval') }} )</span>
                                              <span v-if="sayfayetki.Update"> {{ $t('Send-for-Approval') }} </span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex v-if="item.GenelBilgileri.Tip=='SER'" xs12 sm2 md2>
                                            <v-tooltip bottom>
                                              <v-btn small icon :disabled="!sayfayetki.Update" slot="activator"
                                                @click="git(item.GenelBilgileri)" flat>
                                                <v-icon color="info" dark>edit</v-icon>
                                              </v-btn>
                                              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                              <span v-if="sayfayetki.Update">Düzenle</span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex xs12 sm2 md2>
                                            <v-tooltip slot="append" bottom>
                                              <a target="_blank" small slot="activator"
                                                v-bind:href="'#/fatura/faturadetay/id?' + 'guid=' + item.GenelBilgileri.EFaturaShowID.EFaturaGuid">
                                                <v-btn small icon>
                                                  <v-icon color="info">search</v-icon>
                                                </v-btn>
                                              </a>
                                              <span>{{ $t('Content') }}</span>
                                            </v-tooltip>
                                          </v-flex>

                                        </v-layout>

                                      </v-card>
                                    </v-flex> -->

                                            </v-layout>
                                          </v-card-actions>
                                        </v-card>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>

                                </v-list>
                              </v-card>
                            </v-hover>
                          </v-layout>
                        </v-flex>

                      </v-layout>
                    </v-flex>

                  </v-layout>

                </v-card-actions>
              </v-card>
            </v-flex>


          </v-container>

          <v-container fluid>
            <v-layout>
              <v-flex xs12 sm12 md12>
                <v-layout justify-end="" row>
                  <v-flex xs12 sm12 md4>
                    <v-card flat class="white--text">
                      <v-layout class=" project overdue">
                        <v-flex xs2 sm2 md2>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <v-icon color="info" large="">queue</v-icon>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm10 md10>

                          <v-card-title primary-title="">

                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      Matrah
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>

                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span class="subheading grey--text font-weight-">
                                        {{GelenFatura.Fatura.ToplamTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}

                                      </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                        {{ $t('Total-VAT') }}
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span class="subheading grey--text font-weight-">
                                        {{GelenFatura.Fatura.ToplamKDVTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}} </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                        {{  $t('Deduction-Amount') }}
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span class="subheading grey--text font-weight-">
                                        {{GelenFatura.Fatura.ToplamTevkifatTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                      </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                       {{ $t('Invoice-Amount') }} 
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span class="subheading grey--text font-weight-">
                                        {{GelenFatura.Fatura.FaturaNetTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}} </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-card-title>
                        </v-flex>
                      </v-layout>

                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

          </v-container>



        </v-layout>
      </v-card>
    </v-form>



    <v-dialog v-model="ekstradialog" scrollable="" persistent max-width="350px">
      <v-card>
        <v-card-title> {{ $t('Extra-Details') }}  </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">
            <v-flex xs12 sm6 md6>
              <v-autocomplete :items="doviztipi" hide-details="" item-text="Title" item-value="DovizKod"
                v-model="GelenFatura.Fatura.SatisPara" @change="kurgetir()" :label="$t('Sales-Money')">
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <dovizinput v-model="GelenFatura.Fatura.SatisKur" :etiket="$t('Sales-Currency')" ::autocomplete="autocomplete">
              </dovizinput>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <genelarama
                  v-model="GelenFatura.Fatura.MasrafMrkz2"
                   apiname="MasrafMerkeziAra"
                   :label="$t('Expense-Center-v2')"
                ></genelarama>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <muhasebefistipara :etiket="$t('Accounting-Bill-Type')" v-model="GelenFatura.Fatura.MuhasebeFisTipi">
              </muhasebefistipara>

            </v-flex>

            <v-flex pb-3 xs12 sm12 md12>
              <geneltipara tip="CariTransferKod" v-model="GelenFatura.Fatura.TransferKod"></geneltipara>

            </v-flex>

          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="ekstradialog=false">{{ $t('OK') }}</v-btn>



        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="satirdialog" scrollable="" persistent="" max-width="850px">
      <v-card color="grey lighten-5">
        <v-card-title> {{ $t('Line-Entry') }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">
            <v-flex v-if="!kalemkayitvarmi" xs12 sm12 md12>
              <v-alert type="error" value="true">
                <span> Kayıt bulunamadı</span>

              </v-alert>
            </v-flex>

            <v-flex xs12 pb-2 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>

                    <v-layout row wrap>

                      <v-flex xs12 sm12 md12>
                        <pnrbul @odakkaybi="test2" :satici="GelenFatura.Fatura.Satici"
                          :tip="GelenFatura.Fatura.SaticiTip" v-model="SatirGelenFatura.PnrNo">
                        </pnrbul>
                      </v-flex>

                      <v-flex xs12 sm12 md8>
                        <v-radio-group hide-details v-model="pnrtip">
                          <v-radio :label="pnretiket" :value="true"></v-radio>
                          <v-radio :label="$t('Select-all-Pnr')" :value="false"></v-radio>
                        </v-radio-group>
                      </v-flex>


                      <v-flex xs12 sm4 pt-3 md4>
                        <v-layout row fill-height justify-end full-width align-end="">
                          <v-btn v-if="!pnrkalemloading" @click="kalemGetir();" outline color="info"> {{ $t('List-Items') }} 
                          </v-btn>
                          <v-layout v-if="pnrkalemloading" row fill-height justify-end full-width align-end="">
                            <v-progress-circular indeterminate :width="4" color="info"></v-progress-circular>

                          </v-layout>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>




            <v-flex xs12 0sm12 v-if="itemsgelen.length!=0" md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>

                    <v-layout row wrap>


                      <v-flex xs12 sm6 md6>
                        <yuzdeinput v-model="SatirGelenFatura.KDVYuzde" :etiket="'KDV %'"></yuzdeinput>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <div></div>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" @odakkaybi="tutarblur"
                          v-model="SatirGelenFatura.Tutar" :etiket="$t('Amount-without-VAT')" :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" @odakkaybi="kdvtutarblur"
                          v-model="SatirGelenFatura.KDVTutar" :etiket="$t('VAT-Amount')" :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <v-select :items="Tevkifat" hide-details="" item-text="text" item-value="value"
                          v-model="SatirGelenFatura.TevkifatOran" @change="Tevkifatkdvhesapla()"
                          :label="$t('Deduction-Rate')"></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="SatirGelenFatura.TevkifatTutar"
                          :etiket="$t('Deduction-Amount')" :autocomplete="autocomplete"></parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <yuzdeinput v-model="SatirGelenFatura.StopajOran" :etiket="'Stopaj Oranı'"></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" @odakkaybi="stopajtutarblur"
                          v-model="SatirGelenFatura.StopajTutar" :etiket="$t('Withholding-Amount')" :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex>

                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          
            <v-flex xs12 v-if="itemsgelen.length!=0" pt-2 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap class=" project overdue">
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title> <span class="subheading black--text">
                          Kalemler
                        </span> </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>


                <v-flex v-for="item in itemsgelen" pt-1 v-bind:key="item.id" xs12 sm12 md12>
                  <v-hover>

        

                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">

                    
                      <v-list three-line="">
                       
                        <v-layout row wrap>
                       
                          <v-flex xs1 sm1 md1>
                            &nbsp;
                          </v-flex>
                          
                          <v-flex pl-4 xs11 sm11 md11>

                            <v-tooltip bottom>
                            <template v-slot:activator="{ on }">

                            <v-chip v-on="on" v-if="item.SaticiTip==1" small="" color="pink" text-color="white">
                              <v-avatar>
                                <v-icon color="white">hotel</v-icon>
                              </v-avatar>
                              Hotel
                            </v-chip>
                            <v-chip v-on="on" small="" v-if="item.SaticiTip==1 && item.SaticiKod== GelenFatura.Fatura.Satici.kod"
                              color="white" text-color="green">
                              <v-avatar>
                                <v-icon color="green">check_circle_outline</v-icon>
                              </v-avatar>
                               {{ $t('Relevant-Seller') }} 
                            </v-chip>

                            <v-chip  v-on="on" small=""
                              v-if="GelenFatura.Fatura.SaticiTip==12 && item.TurOperatoru== GelenFatura.Fatura.Satici.kod"
                              color="white" text-color="green">
                              <v-avatar>
                                <v-icon color="green">check_circle_outline</v-icon>
                              </v-avatar>
                               {{ $t('Relevant-Sales-Operator') }} 
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==2" small="" color="orange" text-color="white">
                              <v-avatar>
                                <v-icon color="white">rv_hookup</v-icon>
                              </v-avatar>
                              Transfer
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==3" small="" color="deep-purple" text-color="white">
                              <v-avatar>
                                <v-icon color="white">restaurant</v-icon>
                              </v-avatar>
                              Restaurant
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==4" small="" color="yellow accent-4" text-color="white">
                              <v-avatar>
                                <v-icon color="white">local_see</v-icon>
                              </v-avatar>
                              {{ $t('Tour') }}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==5" small="" color="green" text-color="white">
                              <v-avatar>
                                <v-icon color="white">departure_board</v-icon>
                              </v-avatar>
                              {{ $t('Rent-A-Car') }}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==6" small="" color="teal accent-4" text-color="white">
                              <v-avatar>
                                <v-icon color="white">emoji_people</v-icon>
                              </v-avatar>
                              {{$t('Guide')}}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==7" small="" color="orange" text-color="white">
                              <v-avatar>
                                <v-icon color="white">museum</v-icon>
                              </v-avatar>
                              {{ $t('Museum') }}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==8" small="" color="blue darken-4" text-color="white">
                              <v-avatar>
                                <v-icon color="white">flight_takeoff</v-icon>
                              </v-avatar>
                              {{$t('Airline')}}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==9" small="" color="cyan darken-2" text-color="white">
                              <v-avatar>
                                <v-icon color="white">directions_boat</v-icon>
                              </v-avatar>
                                {{$t('Cruise')}}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==10" small="" color="pink" text-color="white">
                              <v-avatar>
                                <v-icon color="white">category</v-icon>
                              </v-avatar>
                              {{$t('Other')}}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==11" small="" color="brown" text-color="white">
                              <v-avatar>
                                <v-icon color="white">style</v-icon>
                              </v-avatar>
                              {{$t('Visa')}}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==12" small="" color="deep-purple" text-color="white">
                              <v-avatar>
                                <v-icon color="white">style</v-icon>
                              </v-avatar>
                              {{$t('Tour-Operator')}}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==13" small="" color="info" text-color="white">
                              <v-avatar>
                                <v-icon color="white">style</v-icon>
                              </v-avatar>
                              Konsolosluk
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==14" small="" color="lime" text-color="white">
                              <v-avatar>
                                <v-icon color="white">verified_user</v-icon>
                              </v-avatar>
                              {{$t('Insurance')}}
                            </v-chip>

                            <v-chip v-on="on" v-if="item.SaticiTip==15" small="" color="blue" text-color="white">
                              <v-avatar>
                                <v-icon color="white">directions_boat</v-icon>
                              </v-avatar>
                              {{$t('Ferry')}}
                            </v-chip>

                          </template>
                            <span>{{ item.KisiIsim }}</span>
                          </v-tooltip>

                            <span class="font-weight-bold grey--text  body-1 "> {{$t('Seller')}}:
                            </span> {{item.SaticiKod}}-{{item.SaticiAd}}
                            - <span class="font-weight-bold grey--text body-1 "> {{ $t('Operator-Code') }} :
                            </span>{{item.TurOperatoru}}
                        
                          </v-flex>
                          
                        </v-layout>
     
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-card flat="">
                                <v-card-actions>
                                  <v-layout row wrap>
                                    <v-list-tile>
                                      <v-list-tile-content>
                                        <v-layout justify-start="" align-start>
                                          <v-flex xs1 sm1 md1>
                                            <v-checkbox hide-details="" v-model="secilenkayitlar" :value="item">
                                            </v-checkbox>
                                          </v-flex>
                                        </v-layout>
                                      </v-list-tile-content>
                                    </v-list-tile>




                                    <v-flex xs12 sm4 md2>
                                      <v-layout justify-start="" row align-center="">
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout justify-start="" align-center="">

                                                <v-flex>

                                                  <v-list-tile-sub-title>
                                                    <v-layout justify-start="" align-center>
                                                      <div class="font-weight- red--text subheading ">
                                                        {{item.Donem1 | dateformat}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout justify-start="" align-center>
                                                      <div class="font-weight- red--text subheading ">
                                                        {{item.Donem2 | dateformat}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>




                                    <v-flex xs6 sm3 md3>
                                      <v-layout>
                                        <v-flex xs12 sm6 md8>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content style="'overflow=inherit';">

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                      {{ $t('Amount') }}
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold  caption">
                                                      {{ $t('VAT') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                      {{ $t('VAT-Amount') }} :
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold  caption">
                                                      KDV'li Tutar
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm6 md4>
                                          <v-layout row justify-end="" fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end>
                                                      <div class="font-weight-  caption ">
                                                        {{item.Tutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}</div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end="">
                                                      <div class="font-weight-  caption ">
                                                        {{item.KDVYuzde | moneyformat}}%
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end>
                                                      <div class="font-weight-  caption ">
                                                        {{item.KDVTutar | moneyformat }}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}</div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end="">
                                                      <div class="font-weight-  caption ">
                                                        {{item.KDVliTutar| moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>




                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>


                                    <v-flex xs6 sm3 md3>
                                      <v-layout>
                                        <v-flex xs12 sm6 md8>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content style="'overflow=inherit';">

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                       {{ $t('Deduction-Rate') }} :
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold  caption">
                                                        {{  $t('Deduction-Amount') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                      {{ $t('Withholding-Rate') }} :
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold  caption">
                                                      {{ $t('Withholding-Amount') }}
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm6 md4>
                                          <v-layout row justify-end="" fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end>
                                                      <div class="font-weight-  caption ">
                                                        {{item.TevkifatOran | orangoster}}%</div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end="">
                                                      <div class="font-weight-  caption ">
                                                        {{item.TevkifatTutar | moneyformat }}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end>
                                                      <div class="font-weight-  caption ">
                                                        {{item.StopajOran | moneyformat}}%</div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end="">
                                                      <div class="font-weight-  caption ">
                                                        {{item.StopajTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>




                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm4 md2>
                                      <v-layout row align-center justify-center="" fill-height="">
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout row wrap justify-center="">
                                                <v-list-tile-title>
                                                  <v-layout row wrap justify-center="">
                                                    {{ $t('Cost') }}
                                                  </v-layout>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                  <v-layout row wrap justify-end="">
                                                    <div class="red--text subheading">
                                                      {{item.KalemMaliyet | moneyformat }}
                                                      {{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                    </div>
                                                  </v-layout>

                                                </v-list-tile-sub-title>
                                                <v-list-tile-title>
                                                  <v-layout row wrap justify-center="">
                                                    <div class="font-weight green--text caption ">

                                                    </div>
                                                  </v-layout>

                                                </v-list-tile-title>
                                              </v-layout>
                                            </v-list-tile-content>

                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>




                                  </v-layout>
                                </v-card-actions>
                              </v-card>
                            </v-card>
                          </v-flex>
                        </v-layout>
                  
                      </v-list>
                 
                    </v-card>
                  
                  </v-hover>
                </v-flex>

              </v-layout>
            </v-flex>

          </v-layout>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="satirdialog=false">{{$t("cancel_button")}}</v-btn>

          <v-btn v-if="satirkaydetbuton" :disabled="itemsgelen.length==0" color="blue darken-1" flat
            @click.native="satirkaydet()">{{ $t('OK') }}</v-btn>

          <v-btn v-if="satirguncellebuton" color="blue darken-1" flat @click.native="satirguncellekaydet()">{{ $t('Update') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="kalemdialog" v-if="kalemdialog" scrollable="" persistent="" max-width="500px">
      <v-card color="grey lighten-5">
        <v-card-title>Kalem Düzenle</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">


            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>

                    <v-layout row wrap>

                      <v-flex xs12 sm6 md6>
                        <pnrbul v-bind:active="true" v-model="Kalem.PNR_No"></pnrbul>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="Kalem.Tutar" :etiket="$t('Amount')"
                          :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex>
                      <v-flex xs12 sm6 md6>

                        <yuzdeinput v-model="Kalem.KDVYuzde" :etiket="$t('VAT')"></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="Kalem.KDVTutar" :etiket="$t('VAT-Amount')"
                          :autocomplete="autocomplete"></parainputevents>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-select :items="Tevkifat" hide-details="" item-text="text" item-value="value" clearable
                          v-model="Kalem.TevkifatOran" @change="Tevkifatkdvhesapla()" :label="$t('Deduction-Rate')">
                        </v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="Kalem.TevkifatTutar"
                          :etiket="$t('Deduction-Amount')" :autocomplete="autocomplete"></parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <yuzdeinput v-model="Kalem.StopajOran" :etiket="'Stopaj Oranı'"></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="Kalem.StopajTutar" :etiket="$t('Withholding-Amount')"
                          :autocomplete="autocomplete"></parainputevents>
                      </v-flex>


                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>




          </v-layout>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="kalemdialog=false">{{$t("cancel_button")}}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="kalemguncellekaydet()">{{ $t('Update') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>





    <v-dialog v-model="dialogearsiv" scrollable="" persistent="" max-width="400px">
      <v-card color="grey lighten-5">
        <v-card-title> {{  $t('E-Archive-Information-Entry') }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>


                  <v-layout row="" wrap="">
                    <div class="flex md12">

                      <v-select :items="gonderimsekli" hide-details="" v-model="SerbestFatura.EarsivBilgi.GonderimSekli"
                        :label="$t('Sending-Method')" item-text="text" item-value="value" max-height="400"></v-select>

                      <v-select v-model="SerbestFatura.EarsivBilgi.InternetSatis" hide-details="" :items="odemesekli"
                        :label="$t('Internet-Sales')" item-text="text" item-value="value" max-height="400" persistent-hint>
                      </v-select>

                      <v-select :items="webadresleri" hide-details="" v-model="SerbestFatura.EarsivBilgi.WebAdresi"
                        :label="$t('Web-Address')" item-text="Aciklama" clearable item-value="ID" max-height="400"></v-select>

                      <v-select :items="odemesekli1" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeSekli"
                        :label="$t('Payment-Method')" item-text="text" clearable item-value="value" max-height="400"></v-select>

                      <v-select :items="odemesekilleri" hide-details=""
                        v-model="SerbestFatura.EarsivBilgi.OdemeSekliAciklama" :label="$t('Payment-Method-Description')"
                        item-text="Aciklama" clearable item-value="ID" max-height="400"></v-select>

                      <v-select :items="odemearaci" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeAraci"
                        :label="$t('Payment-Instrument')" item-text="Aciklama" clearable item-value="ID" max-height="400"
                        persistent-hint></v-select>

                      <tarihcomp :etiket="$t('Payment-Date')" hide-details="" :tabindex="'17'"
                        v-bind:value="SerbestFatura.EarsivBilgi.OdemeTarihi"
                        v-model="SerbestFatura.EarsivBilgi.OdemeTarihi"></tarihcomp>

                    </div>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">{{$t("cancel_button")}}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">{{$t("save_button")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogyenicari" scrollable="" persistent="" max-width="400px">
      <v-card color="grey lighten-2">
        <v-card-title> {{ $t('Add-New-Current-Card') }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row="" wrap="">
            <v-flex pa-1 xs12 sm6 md12>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-form ref="formcariyegore" v-model="valid" lazy-validation>

                        <v-select :items="musteritipi" hide-details="" v-model="Current.CustomerType" item-text="text"
                          item-value="value" clearable :label="$t('Customertype_label')">
                        </v-select>
                        <v-text-field :rules="[v => !!v || $t('This-area-mandatory')]" :label="$t('Currentcode_label')"
                          v-model="Current.Code" maxlength="15" hide-details="">
                        </v-text-field>
                        <v-text-field hide-details="" maxlength="100" :rules="[v => !!v || $t('This-area-mandatory')]" :label="$t('Title_label')"
                          v-model="Current.Title">
                        </v-text-field>
                        <v-text-field hide-details="" maxlength="15" :label="$t('Phonenumber_label')" v-model="Current.Phone1"></v-text-field>
                        <v-text-field hide-details="" :label="$t('Email_label')" v-model="Current.Email"></v-text-field>
                        <v-text-field hide-details="" :label="$t('Accounting-Code')" maxlength="25" v-model="Current.AccountingCode">
                        </v-text-field>

                      </v-form>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


            <v-flex pa-1 xs12 sm6 md12>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium "> {{ $t('Invoice-Address-Details') }} </span>
                        </v-card-title>
                      </v-card>
                      <v-text-field hide-details="" :label="$t('Taxcenter_label')" v-model="Current.Invoice.TaxOffice">
                      </v-text-field>
                      <v-text-field hide-details="" :label="$t('Taxnumber_label')" v-model="Current.Invoice.TaxNumber">
                      </v-text-field>
                      <v-text-field hide-details="" :label="$t('Postcode_label')" v-model="Current.Invoice.PostCode">
                      </v-text-field>
                      <v-text-field hide-details="" :label="$t('Country_label')" v-model="Current.Invoice.Country"></v-text-field>
                      <v-text-field hide-details="" :label="$t('Province_label')" v-model="Current.Invoice.Province"></v-text-field>
                      <v-textarea hide-details="" no-resize v-model="Current.Invoice.Address" :label="$t('Address_label')">
                      </v-textarea>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>

            </v-flex>


            <v-flex pa-1 xs12 sm12 md12>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>


                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium "> {{ $t('T-C-For-processes-conducted-with-identity-card') }}  </span>
                        </v-card-title>
                      </v-card>

                      <v-text-field hide-details="" :label="$t('Identitynumber_label')" value="" mask="###########" v-model="Current.Invoice.IdentityNumber">
                      </v-text-field>
                      <v-text-field hide-details="" maxlength="50" :label="$t('Name_label')" v-model="Current.Invoice.PerFirstName" required>
                      </v-text-field>
                      <v-text-field hide-details="" :label="$t('Surname_label')" maxlength="50" v-model="Current.Invoice.PerFamilyName" required>
                      </v-text-field>
                      <v-text-field hide-details="" :label="$t('Title_label')" maxlength="50" v-model="Current.Invoice.PerTitle" required>
                      </v-text-field>
                      <v-text-field hide-details="" :label="$t('Othername_label')" maxlength="50" v-model="Current.Invoice.PerMiddleName" required>
                      </v-text-field>
                      <v-text-field hide-details="" :label="$t('Suffixname_label')" maxlength="50" v-model="Current.Invoice.PerNameSuffix" required>
                      </v-text-field>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialogyenicari=false">{{$t("cancel_button")}}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="yenicarikaydet()">{{$t("save_button")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('Your-process-progress') }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogsor" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
        <v-card-text>Bu kayıtı silmek istediğinize emin misiniz?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click.native="dialogsor=false">{{$t("cancel_button")}}</v-btn>
          <v-btn v-if="faturasilbtn" color="info" flat @click="faturasil()">{{ $t('OK') }}</v-btn>

          <v-btn v-if="satirsilbtn" color="info" flat @click="satirsil()">{{ $t('OK') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import parainputevents from '../customcomp/parainputevents'
  import dovizinput from '../customcomp/dovizinput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import tarihcomp from '../customcomp/tarihim'
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import geneltiplist from "@/components/app/customcomp/geneltiplist.vue"
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"
  import rez from "../coper/rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import muhasebefistipara from "@/components/app/coper/component/muhasebefistipara.vue";
  import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
  import tool from "../coper/tools";
  import saticiara from "@/components/app/coper/comp/saticiara.vue"
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

  export default {
    props: {
      operation: ''
    },

    data() {
      return {
        uuid:null,
        pnrno:0,
        kalemkayitvarmi: true,
        pnrkalemloading: false,
        loadingdialog1: true,
        pnretiket: null,
        pnrtip: true,
        islemtipi: 0,
        duzenlenenkayitindex: -1,
        kalemdialog: false,
        secilenkayitlar: [],
        itemsgelen: [],
        blurevents: null,
        itemssaticitip: rez.SaticiTip,
        YurtDisi:false,
        GelenFatura: {
          KayitTipi: 1,
          Fatura: {
            SaticiTip: 1,
            SaticiKod: null,
            FatSeri: null,
            FatNo: null,
            FatTarih: null,
            FatPara: 'TL',
            FatKur: 1,
            SatisPara: 'TL',
            SatisKur: 1,
            VadeTarihi: null,
            HesaplananVade: null,
            EvrakNo:null,
            FaturaTip: 0,
            MasrafMrkz: null,
            MasrafMrkz2: null,
            
            Proforma: false,
            Aciklama: null,
            MuhasebeFisTipi: {
              id: null,
              kod: null,
              isim: null,
              tip: null
            },
            TransferKod: {
              id: null,
              kod: null,
              isim: null,
              tip: null
            },
            Kalemler: [],

            ToplamTuta: 0,
            ToplamKDVliTutar: 0,
            ToplamKDVTutar: 0,
            ToplamTevkifatTutar: 0,
            ToplamStopajTutar: 0,
            FaturaNetTutar: 0,
            Satici: {
              id: null,
              kod: null,
              isim: null,
              tip: null,
              YurtIci_YurtDisi: 0,
              CariKod: null,
              KDV: 0,
            }
          },
          EskiFatura: {
            SaticiTip: null,
            SaticiKod: null,
            FatSeri: null,
            FatNo: null,
            FatTarih: null,
          }
        },

        SatirGelenFatura: {
          PnrNo: null,
          KDVYuzde: 0,
          Tutar: 0,
          KDVTutar: 0,
          KDVliTutar: 0,
          TevkifatTutar: 0,
          TevkifatOran: 0,
          StopajTutar: 0,
          StopajOran: 0,
          MatrahToplam: 0,
          TutarToplam: 0,
          KDVToplam: 0,
          TevkifatToplam: 0
        },
        Kalem: {
          KDVYuzde: 0,
          Tutar: 0,
          KDVliTutar: 0,
          KDVTutar: 0,
          PNR_No: null,
          TevkifatOran: 0,
          TevkifatTutar: 0,
          StopajOran: 0,
          StopajTutar: 0,
          IslemRef: null,
        },
        headerspnr: [{
            text: 'Satıcı Tip',
            value: 'kod'
          },
          {
            text: this.$t('Description'),
            value: 'aciklama',

          }
        ],
        kodmesajı: null,
        progress: false,
        items: [],
        aranacakkelime: null,
        secilendeger: null,
        dialog: false,


        iadevalid: true,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },

        degisenkayit: null,
        dizayngoster: true,
        yazdirbtngoster: false,
        efaturatipi: [{
            text: this.$t('Commercial'),
            value: '0'
          },
          {
            text: this.$t('Basic'),
            value: '1'
          },
          {
            text: this.$t('Export'),
            value: '2'
          }
        ],
        silinecekkayit: null,
        dialogsor: false,
        efaturatipigecici: 0,
        webadresilabel: null,
        odemeseklilabel: null,
        odemesekliaciklamalabel: null,
        odemearacilabel: null,
        odemetarihilabel: null,
        internetsatislabel: null,
        gonderimlabel: null,

        valid: true,
        Current: {
          CompanyCode: '',
          Code: null,
          Title: null,
          Phone1: '',
          CreditLimit1: 0,
          AccountingCode: null,
          Phone2: '',
          Mobile: '',
          Web: '',
          Email: '',
          AccountGroup: '',
          Type: '',
          CMCode: '',
          Reserved1: '',
          Reserved2: '',
          Authorized: '',
          WarningNote: '',
          InfoNote: '',
          CustomerType: '',
          TicketBill: '',
          EInvoiceType: '',
          PostCodeLabel: '',
          EInvoiceCustomer: '',
          MultiPostUse: false,
          EArchiveSendType: false,
          EArchiveSendPaper: false,
          CreditLimit: 0,
          CreditLimitCurrencyAmount: 0,
          CreditLimitCurrency: '',
          WebPassword: '',
          PinCode: '',
          MileCode: '',
          ExpiryDayDomestic: '',
          ExpiryTypeDomestic: '',
          ExpiryDayInt: '',
          ExpiryTypeInt: '',
          ExpiryDayGeneral: '',
          ExpiryTypeGeneral: '',
          DiscountGeneral: '',
          DiscountDom: '',
          DiscountInt: '',
          DiscountDomService: '',
          DiscountIntService: '',
          TaxFree: '',
          ExternalCurrentCode: '',
          ExternalAccountingCode: '',
          StreamCurrentCode: '',
          ArkmanStreamCode: '',
          ExpenseCenter: null,
          TemplateID: '',
          ProfileForced: '',
          EventIDForced: '',
          MainAccount: '',
          Invoice: {
            Address: '',
            PostCode: '',
            Province: '',
            Country: '',
            TaxNumber: '',
            TaxOffice: '',
            IdentityNumber: '',
            PerFirstName: '',
            PerFamilyName: '',
            PerTitle: '',
            PerMiddleName: '',
            PerNameSuffix: '',
            NoPrint: '',
            CustomerPersonelNoInvoice: '',
            DeliveryAddress: '',
            DeliveryName: ''
          },
          Contract: {
            ContractNumber: '',
            ContractDate: '',
            PaymentType: '',
            BankAccountNumber: '',
            BankBranchOffice: '',
            InvoiceRowNumber: '',
            InvoicePassengerName: '',
            InvoiceFlightNumber: ''
          }
        },


        musteritipi: [{
            text: this.$t('Individual'),
            value: 'B'
          },
          {
            text: this.$t('Corporate'),
            value: 'K'
          }
        ],
        dialogyenicari: false,
        reportbroview: false,
        headers: [{
            text: 'Muh. Kod',
            value: 'MuhasebeKodu'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',

          },
          {
            text: this.$t('Reference'),
            value: 'Referans.Kod'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
          },
          {
            text: this.$t('Currency-Amount'),
            value: 'DovizTutar',
          },
          {
            text: this.$t('VAT-Percentage-v2'),
            value: 'KdvYuzde',
          },
          {
            text: this.$t('VAT-Amount'),
            value: 'KdvTutar',
          },
          {
            text: this.$t('Type'),
            value: 'Tip',
          },
          {
            text: this.$t('Discount-Percentage'),
            value: 'IskontoYuzde',
          },
          {
            text: this.$t('Process'),
            value: '',
          }
        ],
        validform: true,
        gibserigoster: true,
        autocomplete: 'autocomplete',
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statesecili: [{
          Kod: 'Kod',
          Unvan: 'Unvan',
          newProp: 'Kod' + ' - ' + 'Unvan'
        }],
        statecari: [],
        secilensatirno: -1,
        search3: '',
        search1: '',
        loading: false,
        caritext: '',
        cariid: '',
        aktifdate: false,
        nefaturasi: 'serbest',

        SerbestFatura: {
          SirketKodu: '',
          SerbestFaturaDetay: [],
          Serbest: true,
          AlisSatis: false,
          FaturaSeri: '',
          FaturaNo: '',
          Update: false,
          FaturaTip: 0, // 0 : Satış faturası , 1 : Iade Faturası
          Evrak: {
            Evrakkod: ''
          },
          Cari: {
            Kod: ''
          },
          EFaturaBilgi: {
            Unvani: '',
            Unvani2: '',
            Adres1: '',
            Adres2: '',
            IlceSehir: '',
            Email: '',
            VergiDairesi: '',
            VergiNo: '',
            TcKimlikNo: '',
            Adi: '',
            Soyadi: '',
            TUnvani: '',
            DigerAdi: '',
            OnAdiEki: '',
          },
          Tarih: null,
          GibSeri: '',
          Vade: null,
          Referans: {
            Kod: ''
          },
          Masraf: {
            Code: ''
          },
          Aciklama: '',
          Doviz: {
            DovizKod: ''
          },
          FTimeStamp:null,
          FaturaUnique:null,
          Kur: 0,
          TevkivatKdv: 0,
          FaturaID: 0,
          CariAktarma: false,
          Tutarlar: {
            ToplamTutar: 0,
            Iskonto: 0,
            FaturaToplam: 0,
            Kdv: 0,
            TevkifatKdv: 0
          },
          Efaturakayit: false,
          Earchiveakayit: false,
          Kagitfatura: false,
          EarsivBilgi: {
            GonderimSekli: '',
            InternetSatis: '',
            pWebAdresi: '',
            OdemeSekli: '',
            OdemeSekliAciklama: '',
            OdemeAraci: '',
            OdemeTarihi: ''
          },
          EFaturaShowID: {
            EFaturaID: null,
            EFaturaGuid: null,
            FaturaStatus: null,
            PdfID: null,
            DizaynID: null,
            XsltID: null

          },
          IadeFaturaBilgi: {
            IadeNedeni: null,
            IstinadenFaturaSeri: null,
            IstinadenFaturaNo: null,
            IstinadenFaturaTarihi: null
          }
        },
        SerbestFaturaDetayList: [],

        SerbestFaturaDetay: {
          MuhasebeKodu: '',
          Aciklama: '',
          LineNote: '',
          Referans: {
            Kod: ''
          },
          Masraf: {
            Code: ''
          },
          Miktar: 0,
          Birim: '',
          BirimFiyat: 0,
          Tutar: 0,
          DovizTutar: 0,
          IskontoYuzde: 0,
          IskontoTutar: 0,
          KdvTip: 'D',
          KdvYuzde: 0,
          KdvTutar: 0,
          KdvMuhKodu: '',
          IskMuhKodu: '',
          KdvKodu: '',
          IstisnaKodu: '',
          TevkifatKodu: '',
          Tip: '',
          TevkifatDetayTutar: 0,
          TevkifatDetayOran: 0,

          TeslimBilgileri: {
            SokakAdi: '',
            BinaAdi: '',
            BinaNo: '',
            TeslimSehir: '',
            TeslimPostaKodu: '',
            TeslimUlke: '',
            TeslimSarti: '',
            GTIPNo: '',
            TransferKodu: '',
            KabinNo: '',
            KabinAdedi: '',
            KabinCinsi: '',
            TeslimOdeme: ''
          }

        },

        SerbestFaturaToplamTutarBilgileri: {
          ToplamTutar: 0,
          Iskonto: 0,
          FaturaToplam: 0,
          Kdv: 0,
          TevkifatKdv: 0
        },

        birim: [{
            text: 'adet',
            value: 'adet'
          },
          {
            text: 'kilo',
            value: 'kilo'
          }, {
            text: this.$t('gram'),
            value: 'gram'
          }, {
            text: this.$t('meter'),
            value: 'metre'
          },
          {
              text: 'litre',
              value: 'litre'
          },
          {
              text: 'm2',
              value: 'm2'
          },
          {
              text: 'dm2',
              value: 'dm2'
          },
          {
              text: 'm3',
              value: 'm3'
          },
        ],


        faturatipi: [{
            text: this.$t('Purchase-Expense'),
            value: 0
          },
          {
            text: this.$t('Sales-Return'),
            value: 1
          },
          {
            text: this.$t('Advance'),
            value: 2
          },
          {
            text: this.$t('Self-employed-Receipt'),
            value: 3
          },
          {
            text: this.$t('Note-of-Expenses'),
            value: 4
          },
          {
            text: this.$t('Withholding-Donation-Receipt'),
            value: 5
          }
        ],
        gonderimsekli: [{
            text: this.$t('Paper'),
            value: 0
          },
          {
            text: this.$t('Electronic'),
            value: 1
          }
        ],

        odemesekli: [{
            text: this.$t('Normal-Sales'),
            value: 0
          },
          {
            text: this.$t('Internet-Sales'),
            value: 1
          }
        ],
        seridisable: false,
        faturagosterbtn: false,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',

        datearsiv: null,
        menuarsiv: false,
        modalarsiv: false,
        dateFormattedarsiv: '',
        yedeksatirkayit: {
          Tutar: 0,
          Kdv: 0,
          Tevkifat: 0,
          iskonto: 0
        },
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        ihracat: false,
        satirdialog: false,
        gibseri: [],
        satiritems: [],
        referaslist: [],
        EvrakTipi1: [],
        kdvtipi: [{
            text: 'D',
            value: 'D'
          },
          {
            text: 'H',
            value: 'H'
          }
        ],
        Tevkifat: [{
            text: '0/10',
            value: 0
          },
          {
            text: '1/10',
            value: 0.1
          },
          {
            text: '2/10',
            value: 0.2
          },
          {
            text: '3/10',
            value: 0.3
          },
          {
            text: '4/10',
            value: 0.4
          },
          {
            text: '5/10',
            value: 0.5
          },
          {
            text: '6/10',
            value: 0.6
          },
          {
            text: '7/10',
            value: 0.7
          },
          {
            text: '8/10',
            value: 0.8
          },
          {
            text: '9/10',
            value: 0.9
          },
          {
            text: '10/10',
            value: 1
          }
        ],

        odemesekli1: [{
            text: this.$t('Credit-Debit-Card'),
            value: '0'
          },
          {
            text: 'EFT-' + this.$t('Transfer-v3'),
            value: '1'
          },
          {
            text: this.$t('Cash-on-delivery'),
            value: '2'
          },
          {
            text: this.$t('Payment-Intermediary'),
            value: '3'
          },
          {
            text: this.$t('Other'),
            value: '4'
          }
        ],

        transferkodu: [{
            text: this.$t('Seaways'),
            value: '1'
          },
          {
            text: this.$t('Railway'),
            value: '2'
          },
          {
            text: this.$t('Highway'),
            value: '3'
          },
          {
            text: this.$t('Airline'),
            value: '4'
          },
          {
            text: this.$t('Post'),
            value: '5'
          },
          {
            text: this.$t('Multiple-Vehicles'),
            value: '6'
          },
          {
            text: this.$t('Fixed-Transportation-Complexes'),
            value: '7'
          },
          {
            text: this.$t('Territorial-Water-Transportation'),
            value: '8'
          }
        ],

        teslimodeme: [{
            text: 'Instrument not defined',
            value: 1
          },
          {
            text: 'Automated clearing house credit',
            value: 2
          },
          {
            text: 'Automated clearing house debit',
            value: 3
          },
          {
            text: 'ACH demand debit reversal',
            value: 4
          },
          {
            text: 'ACH demand credit reversal',
            value: 5
          },
          {
            text: 'ACH demand credit',
            value: 6
          },
          {
            text: 'ACH demand debit',
            value: 7
          },
          {
            text: 'Hold',
            value: 8
          },
          {
            text: 'National or regional clearing',
            value: 9
          },
          {
            text: 'In cash',
            value: 10
          },
          {
            text: 'ACH savings credit reversal',
            value: 11
          },
          {
            text: 'ACH savings debit reversal',
            value: 12
          },
          {
            text: 'ACH savings credit',
            value: 13
          },
          {
            text: 'ACH savings debit',
            value: 14
          },
          {
            text: 'Bookentry credit',
            value: 15
          },
          {
            text: 'Bookentry debit',
            value: 16
          },
          {
            text: 'ACH demand cash concentration/disbursement (CCD) credit',
            value: 17
          },
          {
            text: 'ACH demand cash concentration/disbursement (CCD) debit',
            value: 18
          },
          {
            text: 'ACH demand corporate trade payment (CTP) credit',
            value: 19
          },
          {
            text: 'Cheque',
            value: 20
          },
          {
            text: 'Bankers draft',
            value: 21
          },
          {
            text: 'Certified bankers draft',
            value: 22
          },
          {
            text: 'Bank cheque (issued by a banking or similar establishment)',
            value: 23
          },
          {
            text: 'Certified cheque',
            value: 25
          },
          {
            text: 'Local cheque',
            value: 26
          },
          {
            text: 'ACH demand corporate trade payment (CTP) debit',
            value: 27
          },
          {
            text: 'ACH demand corporate trade exchange (CTX) credit',
            value: 28
          },
          {
            text: 'ACH demand corporate trade exchange (CTX) debit',
            value: 29
          },
          {
            text: 'Credit transfer',
            value: 30
          },
          {
            text: 'Debit transfer',
            value: 31
          },
          {
            text: 'ACH demand cash concentration/disbursement plus (CCD+)',
            value: 32
          },
          {
            text: 'ACH demand cash concentration/disbursement plus (CCD+)',
            value: 33
          },
          {
            text: 'ACH prearranged payment and deposit (PPD)',
            value: 34
          },
          {
            text: ' ACH savings cash concentration/disbursement (CCD) credit',
            value: 35
          },
          {
            text: 'ACH savings cash concentration/disbursement (CCD) debit',
            value: 36
          },
          {
            text: 'ACH savings corporate trade payment (CTP) credit',
            value: 37
          },
          {
            text: 'ACH savings corporate trade payment (CTP) debit',
            value: 38
          },
          {
            text: 'ACH savings corporate trade exchange (CTX) credit',
            value: 39
          },
          {
            text: 'ACH savings corporate trade exchange (CTX) debit',
            value: 40
          },
          {
            text: 'ACH savings cash concentration/disbursement plus (CCD+)',
            value: 41
          },
          {
            text: 'Payment to bank account',
            value: 42
          },
          {
            text: 'ACH savings cash concentration/disbursement plus (CCD+)',
            value: 43
          },
          {
            text: 'Accepted bill of exchange',
            value: 44
          },
          {
            text: 'Referenced home-banking credit transfer',
            value: 45
          },
          {
            text: 'Interbank debit transfer',
            value: 46
          },
          {
            text: 'Home-banking debit transfer',
            value: 47
          },
          {
            text: 'Bank card',
            value: 48
          },
          {
            text: 'Direct debit',
            value: 49
          },
          {
            text: 'Payment by postgiro',
            value: 50
          },
          {
            text: 'Promissory note',
            value: 60
          },
          {
            text: '61    Promissory note signed by the debtor',
            value: 61
          },
          {
            text: 'Promissory note signed by the debtor and endorsed by a bank',
            value: 62
          },
          {
            text: 'Promissory note signed by the debtor and endorsed by a',
            value: 63
          },
          {
            text: ' Promissory note signed by a bank',
            value: 64
          },
          {
            text: 'Promissory note signed by a bank and endorsed by another',
            value: 65
          },
          {
            text: 'Promissory note signed by a third party',
            value: 66
          },
          {
            text: 'Promissory note signed by a third party and endorsed by a',
            value: 67
          },
          {
            text: 'Bill drawn by the creditor on the debtor',
            value: 70
          },
          {
            text: 'Bill drawn by the creditor on a bank',
            value: 74
          },
          {
            text: 'Bill drawn by the creditor, endorsed by another bank',
            value: 75
          },
          {
            text: 'Bill drawn by the creditor on a bank and endorsed by a',
            value: 76
          },
          {
            text: 'Bill drawn by the creditor on a third party',
            value: 77
          },
          {
            text: 'Bill drawn by creditor on third party, accepted and',
            value: 78
          },
          {
            text: 'Not transferable banker s draft',
            value: 91
          },
          {
            text: 'Not transferable local cheque',
            value: 92
          },
          {
            text: 'Reference giro',
            value: 93
          },
          {
            text: 'Urgent giro',
            value: 94
          },
          {
            text: 'Free format giro',
            value: 95
          },
          {
            text: 'Requested method for payment was not used',
            value: 96
          },
          {
            text: 'Clearing between partners',
            value: 97
          }

        ],

        islembilgileri: [{
            text: this.$t('Hard-Copy-Invoice'),
            value: 'false'
          },
          {
            text: this.$t('Electronic-Invoice'),
            value: 'true'
          }
        ],

        doviztipi: [],
        webadresleri: [],
        odemesekilleri: [],
        odemearaci: [],
        dizayn: null,

        ichattipi: [
          'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
        ],

        evethayir: [{
            text: this.$t('Yes'),
            value: 'E'
          },
          {
            text: 'Hayır',
            value: 'H'
          },
        ],

        cmkodu: [
          'C', 'M'
        ],
        dizaynsec: [],
        xsltitems: [],
        masrafmerkezi: [],
        dictionary: {
          custom: {
            carikod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            unvan: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            faturaseri: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            faturano: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },

            dizayn: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            xslt: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            gtip: {
              min: () => this.$t('Must-least-4-digits'),
            }

          }
        },
        sayfabaslik: 'Coper Gelen Fatura',
        satirguncellebuton: false,
        satirkaydetbuton: true,
        StartDate: null,
        EndDate: null,
        NumberOfPolicies: '',
        PolicySum: '',
        TotalDebt: '',
        TotalFlatDebt: '',
        kaydetbuton: true,
        guncellebuton: false,
        silbuton: false,
        detaytevkifat: true,
        text1: '',
        denemevalue: 0,

        biletlerfaturalanmasin: null,
        efaturamukellefi: null,
        loadingdialog: false,
        Kdvmuaf: null,
        ciktiistemiyor: null,
        musteribilgitipi: null,
        profilzorunlu: null,
        eventidzorunlu: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
        ex11: 'false',
        dialogearsiv: false,
        earsivdurum: false,
        guidim: null,
        idim: null,
        ekstradialog: false,
        kredilimiti: 0,
        dizaynIdget: null,
        xsltIdget: null,
        faturasilbtn: false,
        satirsilbtn: false,
        islemturu: null,
        ChangeTarih: null,
        ChangeFaturaNo: null,

      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.sayfayetki.Status = true
      this.sayfayetki.Save = true
      this.sayfayetki.Update = true
      this.sayfayetki.Delete = true

      if (this.sayfayetki.Status == true) {
        this.SerbestFaturaDetayList = []

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }

        this.$http.post(auth.API_URL + 'api/currency/List', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Döviz Tipi'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Döviz Tipi'
            this.snackbar = true
          }
        })



        if (this.$route.query.islem == "yeni") {
          this.sayfabaslik = 'Coper Gelen Fatura'
          this.guncellebuton = false
          this.kaydetbuton = true
          this.islemtipi = 1

          console.log(this.$route.query.uuid);
          if(this.$route.query.uuid != null )
          {
            this.uuid = this.$route.query.uuid;
            this.pnrno = this.$route.query.pnrno;
            
            this.getEFatura(); 
          }

        } else if (this.$route.query.islem == "get") {
          this.loadingdialog = true
          let params = {
            SaticiTip: this.$route.query.st,
            SaticiKod: unescape(this.$route.query.sk.replace('%26','&')),
            FatSeri: this.$route.query.fs,
            FatNo: this.$route.query.fn,
            FatTarih: this.$route.query.ft
          }
          //escape(val.SaticiKod)
          tool.http_post(this, 'GelenFaturaLoad', params).then(

            response => {

              if (response.body.Status == true) {


                this.GelenFatura.Fatura = response.body.data

                this.GelenFatura.EskiFatura.SaticiTip = response.body.data.SaticiTip
                this.GelenFatura.EskiFatura.SaticiKod = response.body.data.SaticiKod
                this.GelenFatura.EskiFatura.FatSeri = response.body.data.FatSeri
                this.GelenFatura.EskiFatura.FatNo = response.body.data.FatNo
                this.GelenFatura.EskiFatura.FatTarih = response.body.data.FatTarih

                this.GelenFatura.KayitTipi = 2
                this.islemtipi = 1
                this.guncellebuton = true
                this.kaydetbuton = false

              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
              }
              this.loadingdialog = false

            },

            response => {
              this.text1 = 'Hata Oluştu, tekrar deneyiniz'
              this.loadingdialog = false
              this.snackbar = true
            }

          );


        } else {
          this.snackbar = true
          this.text1 = 'Hatalı url'
        }

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },

      orangoster: function (m) {
        return m * 100;
      }
    },
    methods: {
     getSaticiTip: function (satisTip) {
      let _resultSaticTipText = null;
      this.itemssaticitip.forEach((element) => {
        if (element.Kod == satisTip) {
          _resultSaticTipText = element.Aciklama;
        }
      });
      return _resultSaticTipText;
      },
      setSaticiTip(val){
        this.GelenFatura.Fatura.SaticiTip = val;
      },
      toplammaliyetBul(secililist) {

        var sonuc = {
          maliyet: 0,
          kdvtutari: 0
        }

        if (secililist.length != 0) {
          secililist.forEach(element => {
            sonuc.maliyet = sonuc.maliyet + element.KalemMaliyet
            sonuc.kdvtutari = sonuc.kdvtutari + element.KDVTutar
          });

        } 
        return sonuc
      },
      stopajtutarblur() {
        if (this.SatirGelenFatura.Tutar != 0) {
          this.SatirGelenFatura.StopajOran = this.SatirGelenFatura.StopajTutar / this.SatirGelenFatura.Tutar * 100
        } else {
          this.SatirGelenFatura.StopajOran = 0
        }
      },
      kdvlitutarblur() {},
      tutarblur() {
        this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.KDVYuzde
        this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran
        this.SatirGelenFatura.StopajTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran

      },
      kdvtutarblur() {

      },
      test2(v) {
        if (String(v).length > 3 && v != null) {
        }
      },

      sontutarkontrol(toplamdeger, toplam, deger) {
        toplam = this.roundNumber(toplam, 2)

        if (toplamdeger < toplam) {
          var fark = toplam - toplamdeger
          var kdvtut = deger + fark
          return kdvtut
        } else if (toplamdeger > toplam) {
          var sonek = this.roundNumber(toplamdeger - deger, 2);
          var eklenecek = toplam - sonek
          var kdvtutar = eklenecek // - fark
          return kdvtutar
        } else {
          return deger
        }
      },
      twodigitcalc(bolunen, bolen) {
        var dizi = []
        var a = parseFloat(bolunen)
        var b = parseFloat(bolen)
        var kactane;
        var ters;
        if (a >= b) {
           kactane = Math.floor(a / b)
           ters = Math.floor(a / kactane)
        } else {
           kactane = Math.floor(b / a)
           ters = Math.floor(kactane / 1)
        }
        if (bolen != 0 && bolunen != 0) {
          var bolum = this.roundNumber(a / b, 2)
          var top = 0
          var kalani = 0
          for (var x = 0; x < b; x++) {
            kalani = a - top
            if (x + 1 != b) {
              dizi.push(bolum)
            } else {
              dizi.push(this.roundNumber(kalani, 2))
            }
            top = top + bolum
          }
          return dizi;
        } else {
          for (let x = 0; x < bolen; x++) {
            dizi.push(0)
          }
          return dizi;
        }




      },
      git(val) {
        var url = "#/fatura/copergelenfatura/id?islem=get&st=" + val.SaticiTip + '&sk=' + val.SaticiKod + '&fs=' + val
          .FatSeri + '&fn=' + val.FatNo + '&ft=' + val.FatTarih
        window.open(url, "_self");
      },
      kalemguncellekaydet() {

        this.Kalem.KDVliTutar = this.Kalem.Tutar + this.Kalem.KDVTutar

        var indexno = this.duzenlenenkayitindex


        var kayit = {
          KDVYuzde: this.Kalem.KDVYuzde,
          Tutar: this.roundNumber(this.Kalem.Tutar, 2),
          KDVliTutar: this.roundNumber(this.Kalem.KDVliTutar, 2),
          KDVTutar: this.roundNumber(this.Kalem.KDVTutar, 2),
          PNR_No: Number(this.Kalem.PNR_No),
          TevkifatOran: this.Kalem.TevkifatOran,
          TevkifatTutar: this.roundNumber(this.Kalem.TevkifatTutar, 2),
          StopajOran: this.Kalem.StopajOran,
          StopajTutar: this.roundNumber(this.Kalem.StopajTutar, 2),
          IslemRef: this.Kalem.IslemRef
        }


        this.GelenFatura.Fatura.Kalemler.splice(indexno, 1, kayit)
        this.kalemdialog = false
        this.diptopla();

      },
      diptopla() {
        this.GelenFatura.Fatura.ToplamTutar = 0
        this.GelenFatura.Fatura.ToplamKDVliTutar = 0
        this.GelenFatura.Fatura.ToplamKDVTutar = 0
        this.GelenFatura.Fatura.ToplamTevkifatTutar = 0
        this.GelenFatura.Fatura.ToplamStopajTutar = 0
        this.GelenFatura.Fatura.FaturaNetTutar = 0


        this.GelenFatura.Fatura.Kalemler.forEach(element => {
          this.GelenFatura.Fatura.ToplamTutar = this.GelenFatura.Fatura.ToplamTutar + element.Tutar
          this.GelenFatura.Fatura.ToplamKDVliTutar = this.GelenFatura.Fatura.ToplamKDVliTutar + element.KDVliTutar
          this.GelenFatura.Fatura.ToplamKDVTutar = this.GelenFatura.Fatura.ToplamKDVTutar + element.KDVTutar
          this.GelenFatura.Fatura.ToplamTevkifatTutar = this.GelenFatura.Fatura.ToplamTevkifatTutar + element
            .TevkifatTutar
          this.GelenFatura.Fatura.ToplamStopajTutar = this.GelenFatura.Fatura.ToplamStopajTutar + element
            .StopajTutar


        });

        this.GelenFatura.Fatura.FaturaNetTutar = this.GelenFatura.Fatura.ToplamKDVliTutar - this.GelenFatura.Fatura
          .ToplamTevkifatTutar


      },

      kalanVarmi(x, y) {
        var sonuc = {
          durum: false,
          bolum: 0,
          kalan: 0
        }

        var c = this.roundNumber(x / y, 2);
        var carpim = c * y
        var kalan = this.roundNumber(100 - carpim, 2)

        if (kalan != 0) {
          sonuc.durum = true
          sonuc.kalan = kalan
          sonuc.bolum = c
        } else {
          sonuc.durum = false
          sonuc.kalan = 0
          sonuc.bolum = c
        }
        return sonuc
      },

      roundNumber(num, scale) {
        if (!("" + num).includes("e")) {
          return +(Math.round(num + "e+" + scale) + "e-" + scale);
        } else {
          var arr = ("" + num).split("e");
          var sig = ""
          if (+arr[1] + scale > 0) {
            sig = "+";
          }
          return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
        }
      },

      esitOranla() {

        if (this.secilenkayitlar.length > 0) {
          if (this.SatirGelenFatura.Tutar > 0) {

            var toplamoran = 0
            var secilenkayityedek = this.secilenkayitlar
            this.secilenkayitlar = []
            this.SatirGelenFatura.MatrahToplam = 0
            this.SatirGelenFatura.KDVToplam = 0
            this.SatirGelenFatura.TevkifatToplam = 0
            this.SatirGelenFatura.TutarToplam = 0
            var giris = true
            var bolmesonuc = this.kalanVarmi(100, secilenkayityedek.length)
            var fiyatindex = 0
            var tutarlarim = this.twodigitcalc(this.SatirGelenFatura.Tutar, secilenkayityedek.length)
            var kdvtutarlarim = this.twodigitcalc(this.SatirGelenFatura.KDVTutar, secilenkayityedek.length)
            var tevkifattutarlarim = this.twodigitcalc(this.SatirGelenFatura.TevkifatTutar, secilenkayityedek.length)
            var stopajtutarlarim = this.twodigitcalc(this.SatirGelenFatura.StopajTutar, secilenkayityedek.length)
            secilenkayityedek.forEach(element => {
              var oran = 0
              if (bolmesonuc.durum == true && giris == true) {
                giris = false
              } else {
                oran = bolmesonuc.bolum / 100
              }
              var indexno = this.itemsgelen.indexOf(element)
              var kayit = {
                PnrNo: element.PnrNo,
                SaticiTip: element.SaticiTip,
                SaticiKod: element.SaticiKod,
                SaticiAd: element.SaticiAd,
                TurOperatoru: element.TurOperatoru,
                Donem1: element.Donem1,
                Donem2: element.Donem2,
                KalemMaliyet: element.KalemMaliyet,
                KDVYuzde: this.SatirGelenFatura.KDVYuzde,
                Tutar: tutarlarim[fiyatindex],
                KDVTutar: kdvtutarlarim[fiyatindex],
                KDVliTutar: tutarlarim[fiyatindex] + kdvtutarlarim[fiyatindex],
                TevkifatTutar: tevkifattutarlarim[fiyatindex],
                TevkifatOran: this.SatirGelenFatura.TevkifatOran,
                StopajTutar: stopajtutarlarim[fiyatindex],
                StopajOran: this.SatirGelenFatura.StopajOran,
                IslemRef: element.IslemRef
              }
              this.SatirGelenFatura.MatrahToplam = this.SatirGelenFatura.MatrahToplam + kayit.Tutar
              this.SatirGelenFatura.KDVToplam = this.SatirGelenFatura.KDVToplam + kayit.KDVTutar
              this.SatirGelenFatura.TevkifatToplam = this.SatirGelenFatura.TevkifatToplam + kayit.TevkifatTutar
              this.SatirGelenFatura.TutarToplam = this.SatirGelenFatura.TutarToplam + kayit.Tutar - kayit
                .TevkifatTutar

              this.itemsgelen.splice(indexno, 1, kayit)
              this.secilenkayitlar.push(kayit)
              fiyatindex++
            });

          } else {
            this.text1 = this.$t('Your-amount-must-be-greater-than-zero');
            this.snackbar = true
          }
        } else {
          this.text1 = this.$t('Please-select-items')
          this.snackbar = true
        }


      },
      maliyetegoreOranlaeski() {

        if (this.secilenkayitlar.length > 0) {
          if (this.SatirGelenFatura.Tutar > 0) {
            this.SatirGelenFatura.MatrahToplam = 0
            this.SatirGelenFatura.KDVToplam = 0
            this.SatirGelenFatura.TevkifatToplam = 0
            var toplammaliyet = 0
            this.secilenkayitlar.forEach(element => {
              toplammaliyet = toplammaliyet + element.KalemMaliyet
            });

            var secilenkayityedek = this.secilenkayitlar
            this.secilenkayitlar = []
            this.SatirGelenFatura.MatrahToplam = 0
            this.SatirGelenFatura.KDVToplam = 0
            this.SatirGelenFatura.TevkifatToplam = 0
            this.SatirGelenFatura.TutarToplam = 0
            var toplamoran = 0

            secilenkayityedek.forEach(element => {

              var oran = 0

              if (element.KalemMaliyet != 0) {
                oran = element.KalemMaliyet / toplammaliyet
              }
              toplamoran = toplamoran + oran
              var indexno = this.itemsgelen.indexOf(element)
              var kayit = {
                PnrNo: element.PnrNo,
                SaticiTip: element.SaticiTip,
                SaticiKod: element.SaticiKod,
                SaticiAd: element.SaticiAd,
                TurOperatoru: element.TurOperatoru,
                Donem1: element.Donem1,
                Donem2: element.Donem2,
                KalemMaliyet: element.KalemMaliyet,
                KDVYuzde: this.SatirGelenFatura.KDVYuzde,
                Tutar: (this.SatirGelenFatura.Tutar) * oran,
                KDVTutar: this.SatirGelenFatura.KDVTutar * oran,
                KDVliTutar: (this.SatirGelenFatura.Tutar) * oran + (this.SatirGelenFatura.KDVTutar) * oran,
                TevkifatTutar: this.SatirGelenFatura.TevkifatTutar * oran,
                TevkifatOran: this.SatirGelenFatura.TevkifatOran,
                StopajTutar: this.SatirGelenFatura.StopajTutar * oran,
                StopajOran: this.SatirGelenFatura.StopajOran,
                IslemRef: element.IslemRef
              }


              this.SatirGelenFatura.MatrahToplam = this.SatirGelenFatura.MatrahToplam + kayit.Tutar
              this.SatirGelenFatura.KDVToplam = this.SatirGelenFatura.KDVToplam + kayit.KDVTutar
              this.SatirGelenFatura.TevkifatToplam = this.SatirGelenFatura.TevkifatToplam + kayit.TevkifatTutar
              this.SatirGelenFatura.TutarToplam = this.SatirGelenFatura.TutarToplam + kayit.Tutar - kayit
                .TevkifatTutar

              this.secilenkayitlar.push(kayit)

              this.itemsgelen.splice(indexno, 1, kayit)
            });

          } else {
            this.text1 = this.$t('Your-amount-must-be-greater-than-zero');
            this.snackbar = true
          }

        } else {
          this.text1 = this.$t('Please-select-items')
          this.snackbar = true
        }





      },
      maliyetegoreOranla() {
        if (this.secilenkayitlar.length > 0) {
          if (this.SatirGelenFatura.Tutar > 0) {
            this.SatirGelenFatura.MatrahToplam = 0
            this.SatirGelenFatura.KDVToplam = 0
            this.SatirGelenFatura.TevkifatToplam = 0
            var toplammaliyet = 0
            var toplamKdv = 0
            var toplamStopajTutar = 0
            var toplamTevkifatTutar = 0
            this.secilenkayitlar.forEach(element => {
              toplammaliyet = toplammaliyet + (element.KalemMaliyet - element.KDVTutar) 
              toplamKdv = toplamKdv + element.KDVTutar
              toplamStopajTutar = toplamStopajTutar + element.StopajTutar
              toplamTevkifatTutar = toplamTevkifatTutar + element.TevkifatTutar
            });
            var secilenkayityedek = this.secilenkayitlar
            this.secilenkayitlar = []
            this.SatirGelenFatura.MatrahToplam = 0
            this.SatirGelenFatura.KDVToplam = 0
            this.SatirGelenFatura.TevkifatToplam = 0
            this.SatirGelenFatura.TutarToplam = 0
            var toplamoran = 0
            var x = 0
            var toplamkdv = 0
            var toplamtutar = 0
            var toplamtevkifat = 0
            var toplamstopaj = 0

            secilenkayityedek.forEach(element => {

              var oran = 0
              var kdvOran = 0
              var tutarOran = 0
              var tevkifatOran = 0
              var stopajOran = 0
              var kalemMaliyetKdvsiz = 0
              var kdvtut = 0
              var tutar = 0
              var tevkifattutar = 0
              var stopajtutar = 0


              if (element.KalemMaliyet != 0) {
                kalemMaliyetKdvsiz = element.KalemMaliyet - element.KDVTutar;

                if (isNaN(element.KDVTutar / toplamKdv)) {
                  kdvtut = 0;  // element.KDVTutar / toplamKdv
                  }else{
                    kdvtut = this.roundNumber(this.SatirGelenFatura.KDVTutar * element.KDVTutar / toplamKdv, 2);  // element.KDVTutar / toplamKdv
                  }

                  if (isNaN(kalemMaliyetKdvsiz / toplammaliyet)) {
                    tutar = 0
                  }else{
                    tutar = this.roundNumber(this.SatirGelenFatura.Tutar * kalemMaliyetKdvsiz / toplammaliyet, 2); // kalemMaliyetKdvsiz / toplammaliyet
                  }

                if (isNaN(element.TevkifatTutar / toplamTevkifatTutar)) {
                  tevkifattutar = 0;
                }else{
                  tevkifattutar = this.roundNumber(this.SatirGelenFatura.TevkifatTutar * element.TevkifatTutar / toplamTevkifatTutar, 2);// bunları hazırla
                }
                if (isNaN(element.StopajTutar / toplamStopajTutar)) {
                  stopajtutar = 0;
                }else{
                  stopajtutar = this.roundNumber(this.SatirGelenFatura.StopajTutar * element.StopajTutar / toplamStopajTutar, 2);  // bunları hazırla
                }
              }

              toplamkdv = toplamkdv + this.roundNumber(kdvtut, 2)
              toplamtutar = toplamtutar + this.roundNumber(tutar, 2)
              toplamtevkifat = toplamtevkifat + this.roundNumber(tevkifattutar, 2)
              toplamstopaj = toplamstopaj + this.roundNumber(stopajtutar, 2)

              if (x == secilenkayityedek.length - 1) {

                  if (isNaN(element.KDVTutar / toplamKdv)) {
                  kdvOran = 0
                  }else{
                    kdvOran = element.KDVTutar / toplamKdv;
                  }

                kdvtut = this.sontutarkontrol(toplamkdv, this.SatirGelenFatura.KDVTutar, this.SatirGelenFatura
                  .KDVTutar * kdvOran)// bu orankları  // element.KDVTutar / toplamKdv ıle tek tek ozel olarak test et 


                  if (isNaN(kalemMaliyetKdvsiz / toplammaliyet)) {
                    tutarOran = 0
                  }else{
                    tutarOran = kalemMaliyetKdvsiz / toplammaliyet;
                  }

                  tutar = this.sontutarkontrol(toplamtutar, this.SatirGelenFatura.Tutar, this.SatirGelenFatura.Tutar * tutarOran)

                
                if (isNaN(element.TevkifatTutar / toplamTevkifatTutar)) {
                  tevkifatOran = 0
                  }else{
                    tevkifatOran = element.TevkifatTutar / toplamTevkifatTutar;
                  }
                  tevkifattutar = this.sontutarkontrol(toplamtevkifat, this.SatirGelenFatura.TevkifatTutar, this
                  .SatirGelenFatura.TevkifatTutar * tevkifatOran)
               

                  if (isNaN(element.StopajTutar / toplamStopajTutar)) {
                    stopajOran = 0
                  }else{
                    stopajOran = element.StopajTutar / toplamStopajTutar;
                  }
                stopajtutar = this.sontutarkontrol(toplamstopaj, this.SatirGelenFatura.StopajTutar, this
                  .SatirGelenFatura.StopajTutar * stopajOran)

              }


              var indexno = this.itemsgelen.indexOf(element)
              var kayit = {
                PnrNo: element.PnrNo,
                SaticiTip: element.SaticiTip,
                SaticiKod: element.SaticiKod,
                SaticiAd: element.SaticiAd,
                TurOperatoru: element.TurOperatoru,
                Donem1: element.Donem1,
                Donem2: element.Donem2,
                KalemMaliyet: element.KalemMaliyet,
                KDVYuzde: this.SatirGelenFatura.KDVYuzde,
                Tutar: this.roundNumber(tutar, 2),
                KDVTutar: this.roundNumber(kdvtut, 2),
                KDVliTutar: this.roundNumber(tutar, 2) + this.roundNumber(kdvtut, 2),
                TevkifatTutar: this.roundNumber(tevkifattutar, 2),
                TevkifatOran: this.SatirGelenFatura.TevkifatOran,
                StopajTutar: this.roundNumber(stopajtutar, 2),
                StopajOran: this.SatirGelenFatura.StopajOran,
                IslemRef: element.IslemRef
              }

              this.SatirGelenFatura.MatrahToplam = this.SatirGelenFatura.MatrahToplam + kayit.Tutar
              this.SatirGelenFatura.KDVToplam = this.SatirGelenFatura.KDVToplam + kayit.KDVTutar
              this.SatirGelenFatura.TevkifatToplam = this.SatirGelenFatura.TevkifatToplam + kayit.TevkifatTutar
              this.SatirGelenFatura.TutarToplam = this.SatirGelenFatura.TutarToplam + kayit.Tutar - kayit
                .TevkifatTutar

              this.secilenkayitlar.push(kayit)

              this.itemsgelen.splice(indexno, 1, kayit)
              x = x + 1
            });

          } else {
            this.text1 = this.$t('Your-amount-must-be-greater-than-zero');
            this.snackbar = true
          }

        } else {
          this.text1 = this.$t('Please-select-items')
          this.snackbar = true
        }





      },
      kalemGetir() {

        this.secilenkayitlar = []
        this.itemsgelen = []
        this.pnrkalemloading = true

        var yeniliste = []

        let params = {
          Tip: 1,
          Id: this.SatirGelenFatura.PnrNo,
          FaturaParaBirimi: this.GelenFatura.Fatura.FatPara,
          KomisyonDus: false

        }


        tool.http_post(this, 'GelenFaturaPNRKalemList', params).then(
          response => {

            if (response.body.Status == true) {

         
              this.SatirGelenFatura.KDVYuzde = this.GelenFatura.Fatura.Satici.KDV



              response.body.data.forEach(element => {
                var kayit = {
                  PnrNo: this.SatirGelenFatura.PnrNo,
                  SaticiTip: element.SaticiTip,
                  SaticiKod: element.Satici.kod,
                  SaticiAd: element.Satici.isim,
                  TurOperatoru: element.TurOperatoru.kod,
                  Donem1: element.Donem1,
                  Donem2: element.Donem2,
                  KalemMaliyet: element.KalemMaliyet,
                  KDVYuzde: element.KdvOrani,
                  Tutar: 0,
                  KDVTutar: element.KdvTutari,
                  KDVliTutar: 0,
                  TevkifatTutar: 0,
                  TevkifatOran: 0,
                  StopajTutar: 0,
                  StopajOran: 0,
                  IslemRef: element.IslemRef,
                  KisiIsim:element.KisiIsim
                }


                yeniliste.push(kayit);
              });

              this.itemsgelen = yeniliste


              if (response.body.data.length > 0) {
                this.kalemkayitvarmi = true
              } else {
                this.kalemkayitvarmi = false
              }

              this.pnrkalemloading = false

              
              if (this.GelenFatura.Fatura.SaticiTip == 12) {
                if (this.pnrtip == false) {
                  this.secilenkayitlar = this.itemsgelen
                  let sonuc = this.toplammaliyetBul(this.secilenkayitlar)
                  this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)
                  this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.KDVYuzde
                } else {

                  this.secilenkayitlar = []
                  this.itemsgelen.forEach(element => {
                    if (element.TurOperatoru == this.GelenFatura.Fatura.Satici.kod) {
                      this.secilenkayitlar.push(element)
                    }
                  });
                  let sonuc = this.toplammaliyetBul(this.secilenkayitlar)

                  this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)
                  this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura
                    .KDVYuzde
                }

              } else {

                if (this.pnrtip == false) {
                  this.secilenkayitlar = this.itemsgelen
                  let sonuc = this.toplammaliyetBul(this.secilenkayitlar)

                  this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)
                  this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura
                    .KDVYuzde

                } else {
                  this.secilenkayitlar = []
                  this.itemsgelen.forEach(element => {
                    if (element.SaticiKod == this.GelenFatura.Fatura.Satici.kod) {
                      this.secilenkayitlar.push(element)
                    }
                  });

                  let sonuc = this.toplammaliyetBul(this.secilenkayitlar)
                 
                  this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)
                  this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura
                    .KDVYuzde
                }
              }
            } else {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
              this.pnrkalemloading = false
              this.kalemkayitvarmi = false
            }
          },

          response => {
            this.text1 = 'Hata Oluştu, tekrar deneyiniz'
            this.snackbar = true
            this.pnrkalemloading = false
            this.kalemkayitvarmi = false
          }
        );



      },
      getparabirimiDefault(val){
        return helpers.getparabirimiDefault(val)
      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
      faturatoplambul() {
        this.SerbestFatura.Tutarlar.FaturaToplam = 0
        this.satiritems.forEach(element => {
          if (element.KdvTip == 'H') {
            this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.FaturaToplam + element
              .Tutar +
              element
              .KdvTutar - this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv

          } else {
            this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.FaturaToplam + element
              .Tutar -
              this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv
          }
        });
      },
      Yazdir() {
        this.dizaynbilgigetir(this.SerbestFatura.EFaturaShowID.DizaynID);

        if (this.SerbestFatura.EFaturaShowID.PdfID != 0) {
          var prm = {
            id: this.SerbestFatura.EFaturaShowID.EFaturaID,
            guid: this.SerbestFatura.EFaturaShowID.EFaturaGuid
          };

          this.$refs.reportbrosablon.Print(prm, this.SerbestFatura.EFaturaShowID.PdfID).then(
            confirm => {
              if (confirm.sonuc == true) {

              } else {
                this.text1 = confirm.mesaj
                this.snackbar = true
              }
            });
        } else {
          this.text1 = this.$t('design-you-selected-does-include-invoice-present-design-Invoice-screen')
          this.snackbar = true
        }
      },
      xsltgetir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var paramsxslt = {
          CompanyCode: credentials.SirketKodu,

        }
        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body

          this.SerbestFatura.EFaturaShowID.XsltID = this.xsltIdget;

        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })

      },
      dizaynbilgigetir(Faturaid) {
        this.dizaynsec.forEach(element => {
          if (element.FaturaId == Faturaid) {
            this.SerbestFatura.EFaturaShowID.XsltID = element.FaturaXsltId
            this.SerbestFatura.EFaturaShowID.PdfID = element.FaturaPdfID
          }
        });
      },
      yenicarikaydet() {

        if (this.$refs.formcariyegore.validate()) {
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          this.Current.CompanyCode = credentials.SirketKodu
          var current = this.Current
          this.$http.post(auth.API_URL + 'api/Current/New', current, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            if (response.body.Status === true) {

              var seciliitems = [{
                text: this.Current.Code + '-' + this.Current.Title,
                id: this.Current.Code
              }]

              this.statecari = seciliitems
              this.SerbestFatura.Cari.Kod = this.Current.Code;

               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true

              this.Current.Code = null;
              this.Current.Title = null;
              this.Current.Phone1 = null;
              this.Current.Email = null;
              this.Current.Authorized = null;
              this.Current.CustomerType = null;
              this.Current.EInvoiceType = null;
              this.Current.EArchiveSendType = false;
              this.Current.Invoice.Address = null;
              this.Current.Invoice.PostCode = null;
              this.Current.Invoice.Province = null;
              this.Current.Invoice.Country = null;
              this.Current.Invoice.TaxNumber = null;
              this.Current.Invoice.TaxOffice = null;
              this.Current.Invoice.IdentityNumber = null;
              this.Current.Invoice.PerFirstName = null;
              this.Current.Invoice.PerFamilyName = null;
              this.Current.Invoice.PerTitle = null;
              this.Current.Invoice.PerMiddleName = null;
              this.Current.Invoice.PerNameSuffix = null;
              this.Current.Invoice.CustomerPersonelNoInvoice = null;
              this.Current.Invoice.DeliveryAddress = null;
              this.Current.Invoice.DeliveryName = null;

              this.cariislemler();

              this.dialogyenicari = false;

            } else if (response.body.Status === false) {
               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true
            }
          }, (response) => {
            if (response.status === 0) {
               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true
            } else {
              let data ={
              response: response,
              request: current,
              api:'Current/New',
              type:2,
              message: response.body.ExceptionMessage
              };
              this.$refs.showMessage.open(data);
            }
          })
        } else {
          this.text1 = this.$t('Please-fill-required-fields');
          this.snackbar = true
        }
      },
      satirguncellekaydet() {

        const index = this.secilensatirno

        var degisenkayit = {}

        var yedeksatiritems = []

        yedeksatiritems = this.satiritems

        this.satiritems = []

        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar - this.yedeksatirkayit
          .Tutar
        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv - this.yedeksatirkayit.Kdv
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv - this.yedeksatirkayit
          .Tevkifat
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto - this.yedeksatirkayit.iskonto


        if (this.SerbestFaturaDetay.DovizTutar > 0) {
          var n = this.SerbestFaturaDetay.DovizTutar

        }

        var satiryeni = {
          TeslimBilgileri: {
            SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
            BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
            BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
            TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
            TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
            TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
            TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
            GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
            TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
            KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
            KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
            KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
            TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
          },
          MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
          Aciklama: this.SerbestFaturaDetay.Aciklama,
          Referans: {
            Kod: this.SerbestFaturaDetay.Referans.Kod
          },
          Masraf: {
            Code: this.SerbestFaturaDetay.Masraf.Code
          },
          Miktar: this.SerbestFaturaDetay.Miktar,
          LineNote: this.SerbestFaturaDetay.LineNote,
          Birim: this.SerbestFaturaDetay.Birim,
          BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
          Tutar: this.SerbestFaturaDetay.Tutar,
          TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
          DovizTutar: this.SerbestFaturaDetay.DovizTutar,
          TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
          IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
          IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
          KdvKodu: this.SerbestFaturaDetay.KdvKodu,
          KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
          IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
          KdvTutar: this.SerbestFaturaDetay.KdvTutar,
          KdvTip: this.SerbestFaturaDetay.KdvTip,
          KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
          IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
          TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
          Tip: this.SerbestFaturaDetay.Tip,
          AdresBilgi: {
            Unvani: null,
            Unvani2: null,
            Adres1: null,
            Adres2: null,
            IlceSehir: null,
            Email: null,
            VergiDairesi: null,
            VergiNo: null,
            TcKimlikNo: null,
            Adi: null,
            Soyadi: null,
            TUnvani: null,
            DigerAdi: null,
            OnAdiEki: null
          },
          EfaturaDetayBilgileri: {
            SiparisID: null,
            SiparisTarihi: null
          },
          AdresBilgi: {
            Unvani: null,
            Unvani2: null,
            Adres1: null,
            Adres2: null,
            IlceSehir: null,
            Email: null,
            VergiDairesi: null,
            VergiNo: null,
            TcKimlikNo: null,
            Adi: null,
            Soyadi: null,
            TUnvani: null,
            DigerAdi: null,
            OnAdiEki: null
          }
        }




        for (var i = 0; i < yedeksatiritems.length; i++) {


          if (index == i) {
            this.satiritems.push(satiryeni)
          } else {
            this.satiritems.push(yedeksatiritems[i])
          }
        }

        this.satirdialog = false
        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar + satiryeni.Tutar
        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv + satiryeni.KdvTutar
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + satiryeni
          .TevkifatDetayTutar
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satiryeni.IskontoTutar
        this.faturatoplambul();

      },
      faturaiade() {

        var url = '#/fatura/coperiade/id?' + 'ft=' + this.GelenFatura.Fatura.FatTarih + '&sk=' + this.GelenFatura.Fatura
          .Satici.kod + '&st=' + this.GelenFatura.Fatura.SaticiTip + '&fs=' +
          this.GelenFatura.Fatura.FatSeri + '&fn=' + this.GelenFatura.Fatura.FatNo + '&islem=yeni'
        window.open(url, '_target')
      },
      satirsilsor(item) {
        this.dialogsor = true;
        this.faturasilbtn = false;
        this.satirsilbtn = true,
          this.silinecekkayit = item
      },
      faturasilsor() {
        this.dialogsor = true;
        this.faturasilbtn = true;
        this.satirsilbtn = false
      },
      satirsil(a) {

        this.$refs.onaydialog.open("this.$t('Are-you-sure-you-want-to-delete-this-record')", 1).then(
          sonuc => {
            if (sonuc == true) {
              const index = this.GelenFatura.Fatura.Kalemler.indexOf(a)
              if (index != -1) {
                this.GelenFatura.Fatura.Kalemler.splice(index, 1)
                this.dialogsor = false;
               this.diptopla();

              }
            }
          });
      },
      satirduzenle(a) {




        var kayit = {
          KDVYuzde: a.KDVYuzde,
          Tutar: a.Tutar,
          KDVliTutar: a.KDVliTutar,
          KDVTutar: a.KDVTutar,
          PNR_No: a.PNR_No,
          TevkifatOran: a.TevkifatOran,
          TevkifatTutar: a.TevkifatTutar,
          StopajOran: a.StopajOran,
          StopajTutar: a.StopajTutar,
          IslemRef: a.IslemRef
        }

        this.Kalem = kayit

        this.duzenlenenkayitindex = this.GelenFatura.Fatura.Kalemler.indexOf(a);
        this.kalemdialog = true
      },
      tarihkontrol(v) {

        if (v != "0001-01-01T00:00:00" && v != null) {
          var parts1 = v.split("-");
          return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
        } else {
          return null;
        }
      },
      cariislemler() {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'))
        var params = {
          Code: this.SerbestFatura.Cari.Kod,
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/Current/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.unvan = response.body.Title

          if (response.body.CreditLimit == null || response.body.CreditLimit == '') {

            this.kredilimiti = 0
          } else {
            this.kredilimiti = 0
          }

          this.SerbestFatura.EFaturaBilgi.Unvani = response.body.Title
          this.SerbestFatura.EFaturaBilgi.Adres1 = response.body.Invoice.Address
          this.SerbestFatura.EFaturaBilgi.IlceSehir = response.body.Invoice.Province
          this.SerbestFatura.EFaturaBilgi.Email = response.body.Email
          this.SerbestFatura.EFaturaBilgi.VergiDairesi = response.body.Invoice.TaxOffice
          this.SerbestFatura.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber
          this.SerbestFatura.EFaturaBilgi.TcKimlikNo = response.body.Invoice.IdentityNumber
          this.SerbestFatura.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName
          this.SerbestFatura.EFaturaBilgi.Soyadi = response.body.Invoice.PerFamilyName
          this.SerbestFatura.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle
          this.SerbestFatura.EFaturaBilgi.DigerAdi = response.body.Invoice.PerMiddleName
          this.SerbestFatura.EFaturaBilgi.OnAdiEki = response.body.Invoice.PerNameSuffix

          this.efaturatipigecici = String(response.body.EInvoiceType);


          //ana sirket e faturacı değilse kağıt fatura
          if (credentials.EFatura != '1') {

            this.SerbestFatura.Efaturakayit = false
            this.SerbestFatura.Earchiveakayit = false
            this.SerbestFatura.KagitFatura = true
          }


          if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '1') {
            // ana sirket efatura cari efatura o zaman efaturacı
            this.SerbestFatura.Efaturakayit = true
            this.SerbestFatura.Earchiveakayit = false
            this.SerbestFatura.KagitFatura = false

          }

          if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '0') {
            if (credentials.EArsiv == '1') {
              //anasirket efatura cari earsiv  o zaman earşivci
              this.SerbestFatura.Earchiveakayit = true
              this.SerbestFatura.Efaturakayit = false
              this.SerbestFatura.KagitFatura = false
            } else {
              this.SerbestFatura.Earchiveakayit = false
              this.SerbestFatura.Efaturakayit = false
              this.SerbestFatura.KagitFatura = true
            }
          }


          var params1 = {
            CompanyCode: credentials.SirketKodu,
            PassiveControl: true,

          }

          if (this.SerbestFatura.Efaturakayit == true) {



            if (this.$route.query.islem != "yenigelenevrak" && this.$route.query.islem != "gelenevrak") {
              this.gibserigoster = true;
            }

            this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.gibseri = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else if (this.SerbestFatura.Earchiveakayit == true) {

            if (this.$route.query.islem != "yenigelenevrak" && this.$route.query.islem != "gelenevrak") {
              this.gibserigoster = true;
            }



            this.$http.post(auth.API_URL + 'api/Definitions/GibSerialEarchiveList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.gibseri = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else if (this.SerbestFatura.KagitFatura == true) {
            this.gibserigoster = false;
          }

        }, (response) => {
          if (response.status === 0) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })


      },
      guncelle: guncelle,
      satirekle: satirekle,
      ekle: ekle,
      getDateNow: getDateNow,
      getDateNow1: getDateNow1,
      toDateformat: toDateformat,
      carigetir: carigetir,
      Kaydet: Kaydet,
      satirkaydet: satirkaydet,
      kdvhesapla: kdvhesapla,
      iskontohesapla: iskontohesapla,
      iskontooranhesapla: iskontooranhesapla,
      Tevkifatkdvhesapla: Tevkifatkdvhesapla,
      anatevkifatkdvkontrol: anatevkifatkdvkontrol,
      anatevkifatiptal: anatevkifatiptal,
      kurgetir: kurgetir,
      kurgetir2: kurgetir2,
      tutardetayhesaplar: tutardetayhesaplar,
      earsivbilgigir: earsivbilgigir,
      faturasil: faturasil,
      getEFatura:getEFatura,
    },
    beforeMount: beforeMount,
    components: {
      'parainputevents': parainputevents,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      masrafmerkezicomp,
      geneltiplist,
      yetkidialog,
      onaydialog,
      genelarama,
      pnrbul,
      geneltipara,
      muhasebefistipara,
      saticiara,
      snackbarcomp

    },
    watch: {

      'secilenkayitlar': function (val) {

        var sonuc = this.toplammaliyetBul(val)

        this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)

        this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.KDVYuzde


        this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran

        this.SatirGelenFatura.StopajTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran


      },
      'GelenFatura.Fatura.Satici.CariKod': function (val) {

      },

      'SatirGelenFatura.KDVYuzde': function (val) {
        var sonuc = this.toplammaliyetBul(this.secilenkayitlar)

   
        if(typeof val != "undefined"){
        this.SatirGelenFatura.Tutar = sonuc.maliyet / ((val / 100) + 1)

        this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * val

        this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran

        this.SatirGelenFatura.StopajTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran

        }




        //   this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran

      },
      'SatirGelenFatura.TevkifatOran': function (val) {
        if (val > 0 && this.SatirGelenFatura.KDVTutar > 0) {
          this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * val
        } else {
          this.SatirGelenFatura.TevkifatTutar = 0
        }
      },
      'SatirGelenFatura.StopajOran': function (val) {
        if (val > 0 && this.SatirGelenFatura.Tutar > 0) {
          this.SatirGelenFatura.StopajTutar = (this.SatirGelenFatura.Tutar / 100) * val
        } else {
          this.SatirGelenFatura.StopajTutar = 0
        }
      },
      'SatirGelenFatura.Tutar': function (val) {

      },

      'Kalem.KDVYuzde': function (val) {
        if (val > 0) {
          this.Kalem.KDVTutar = (this.Kalem.Tutar / 100) * val
        }
      },
      'Kalem.TevkifatOran': function (val) {
        if (val > 0 && this.Kalem.KDVTutar > 0) {
          this.Kalem.TevkifatTutar = this.Kalem.KDVTutar * val
        } else {
          this.Kalem.TevkifatTutar = 0
        }
      },
      'Kalem.StopajOran': function (val) {
        if (val > 0 && this.Kalem.Tutar > 0) {
          this.Kalem.StopajTutar = (this.Kalem.Tutar / 100) * val
        } else {
          this.Kalem.StopajTutar = 0
        }
      },
      'SerbestFatura.FaturaTip': function (val) {

        if (val == 1) {


          this.$refs.onaydialog.open(
            this.$t('Details-regarding-return-invoice-will-entered-after-save-update-process'), 2).then(
            sonuc => {

              if (sonuc == true) {

              }
            });
        }
      },
      search1(val) {
        val && this.carigetir(val)
      },
      'SerbestFatura.Cari.Kod': function (kod) {
        if (kod != null) {
          this.cariislemler();
        }
      },
      'GelenFatura.Fatura.SatisPara': function (dovizkod) {

        if (dovizkod != null && this.islemtipi == 1) {
        }
      },
      'GelenFatura.Fatura.FatPara': function (dovizkod) {
        if (dovizkod != null && this.islemtipi == 1) {
          //     this.kurgetir2();
        }
      },



    }
  }


  function getEFatura() {
  //this.status.loading = true;
  setTimeout(() => {
    var prm = {
      UUID: this.uuid,
      PNR_No:this.pnrno

    };
    tool.api_post(this, "EFatura/GetInvoiceHtml", prm).then(
      (response) => {
        //this.status.loading = false;

        if (response.body.Status == true) {

          this.GelenFatura.Fatura.FatSeri = response.body.data.FaturaNo.substring(0, 3);
          this.GelenFatura.Fatura.FatNo = parseInt(response.body.data.FaturaNo.substring(7, 16));
          this.GelenFatura.Fatura.FatTarih = response.body.data.FaturaTarihi;
          this.GelenFatura.Fatura.VadeTarihi = response.body.data.FaturaTarihi;
          this.GelenFatura.Fatura.HesaplananVade = response.body.data.FaturaTarihi;
          
          this.GelenFatura.Fatura.Aciklama = this.uuid;

          this.GelenFatura.Fatura.FatPara = response.body.data.ParaBirimi;

          if(response.body.data.Invoice.paymentExchangeRateField != null)
          {
            this.GelenFatura.Fatura.FatKur = response.body.data.Invoice.paymentExchangeRateField.calculationRateField.valueField;
          }

          if(this.GelenFatura.Fatura.FatPara=="TRY")
          {
            this.GelenFatura.Fatura.FatPara="TL";
          }
          

        

          this.GelenFatura.Fatura.SaticiTip=response.body.data.CoperDefGelenFatura.SaticiTip;
          this.GelenFatura.Fatura.SaticiKod=response.body.data.CoperDefGelenFatura.SaticiKod;


          var satici = { kod: response.body.data.CoperDefGelenFatura.SaticiKod }

          this.GelenFatura.Fatura.Satici=satici

          
          this.GelenFatura.Fatura.Kalemler=response.body.data.CoperDefGelenFatura.Kalemler;

          this.diptopla();

          //this.response = response.body.data;
          //this.html=response.body.data.InvoiceHtlm;

        } else {
          //this.status.text = response.body.ErrorList[0];
          //this.status.show = true;
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true
        }
      },
      (response) => {
        //this.status = tool.responseToStatus(response);
        this.text1 = "Hata Oluştu. Detaylar için consol ekranına bakınız";
          this.snackbar = true
      }
    );
  }, 500);
}

  function tutardetayhesaplar() {

    if (this.SerbestFatura.Kur != null && this.SerbestFatura.Kur != 0 && this.SerbestFatura.Kur != '' && this
      .SerbestFaturaDetay
      .Tutar != 0) {
      this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Tutar / this.SerbestFatura.Kur
    }

    if (this.SerbestFaturaDetay.IskontoYuzde != null && this.SerbestFaturaDetay.IskontoYuzde != '') {

      var params1 = {
        Tutar: this.SerbestFaturaDetay.Tutar,
        IskontoOran: this.SerbestFaturaDetay.IskontoYuzde
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        }
      })
    } else {
      this.SerbestFaturaDetay.KdvTip != null
      this.SerbestFaturaDetay.IskontoYuzde = 0
      this.SerbestFaturaDetay.IskontoTutar = 0
    }

    if (this.SerbestFaturaDetay.IskontoTutar != null && this.SerbestFaturaDetay.IskontoTutar != '' && this
      .SerbestFaturaDetay
      .KdvYuzde != null && this.SerbestFaturaDetay.KdvYuzde != '') {
      var params1 = {
        KdvTip: this.SerbestFaturaDetay.KdvTip,
        Tutar: this.SerbestFaturaDetay.Tutar,
        IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
        KdvOran: this.SerbestFaturaDetay.KdvYuzde
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetTaxAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFaturaDetay.KdvTutar = response.body.KdvTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Kdv Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Kdv Hesapla'
          this.snackbar = true
        }
      })
    } else {
      this.SerbestFaturaDetay.KdvYuzde = 0
      this.SerbestFaturaDetay.KdvTutar = 0
    }

    if (this.SerbestFaturaDetay.TevkifatDetayOran != null && this.SerbestFaturaDetay.TevkifatDetayOran != '' && this
      .SerbestFaturaDetay
      .KdvTutar != '' && this.SerbestFaturaDetay.KdvTutar != null && this.detaytevkifat == true) {

      var params1 = {
        TevkifatOran: this.SerbestFaturaDetay.TevkifatDetayOran,
        KdvTutar: this.SerbestFaturaDetay.KdvTutar
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFaturaDetay.TevkifatDetayTutar = response.body.TevkifatTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        }
      })
    } else {
      this.SerbestFaturaDetay.TevkifatDetayOran = '0.0'
    }

  }

  function kurgetir() {

    var params1 = {
      Tarih: this.GelenFatura.Fatura.FatTarih,
      DovizKod: this.GelenFatura.Fatura.SatisPara
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'))

    this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
      headers: auth.getAuthCompaniesInfo()
    }).then((response) => {
        if(response.body == 0.0){
          this.GelenFatura.Fatura.SatisKur = 1
          }else{
          this.GelenFatura.Fatura.SatisKur = response.body
          }
      
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-GetWebRate'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-GetWebRate'
        this.snackbar = true
      }
    })

  }

  function kurgetir2() {

    var params1 = {
      Tarih: this.GelenFatura.Fatura.FatTarih,
      DovizKod: this.GelenFatura.Fatura.FatPara
    }

    this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
      headers: auth.getAuthCompaniesInfo()
    }).then((response) => {
          if(response.body == 0.0){
          this.GelenFatura.Fatura.FatKur = 1
          }else{
          this.GelenFatura.Fatura.FatKur = response.body
          }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-GetWebRate'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-GetWebRate'
        this.snackbar = true
      }
    })

  }



  function anatevkifatkdvkontrol() {
    if (this.SerbestFatura.TevkivatKdv != 0 && this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura
      .TevkivatKdv !=
      '') {
      if (this.SerbestFaturaDetay.TevkifatDetayOran != 0 && this.SerbestFaturaDetay.TevkifatDetayOran != null && this
        .SerbestFaturaDetay
        .TevkifatDetayOran != '') {

        this.text1 = this.$t('Deduction-Rate-Selected-Free-Invoice-Detail-Screen')
        this.snackbar = true
        this.SerbestFatura.TevkivatKdv = null

      } else {

        this.detaytevkifat = false
        this.SerbestFaturaDetay.TevkifatDetayOran = 0
        this.SerbestFaturaDetay.TevkifatDetayTutar = 0
      }


    } else {
      this.detaytevkifat = true
    }
  }

  function anatevkifatiptal() {

    if (this.SerbestFatura.TevkivatKdv === 0 || this.SerbestFatura.TevkivatKdv === null || this.SerbestFatura
      .TevkivatKdv ===
      '') {
      this.detaytevkifat = true
    }
  }

  function Tevkifatkdvhesapla() {
    var params1 = {
      TevkifatOran: this.SerbestFaturaDetay.TevkifatDetayOran,
      KdvTutar: this.SerbestFaturaDetay.KdvTutar
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.TevkifatDetayTutar = response.body.TevkifatTutar
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function satirekle() {
    
    if (this.GelenFatura.Fatura.Satici.kod != null & this.GelenFatura.Fatura.Satici.kod != '') {


      if (this.GelenFatura.Fatura.Satici.CariKod == null || this.GelenFatura.Fatura.Satici.CariKod == "") {
        this.text1 = this.$t('seller-you-selected-does-not-have-any-current-codes')
        this.snackbar = true
      }

      this.satirdialog = true
      this.secilenkayitlar = []
      this.pnretiket = this.GelenFatura.Fatura.Satici.kod + this.$t('Select-pnr-belonging-seller')
      this.itemsgelen = []
      this.SatirGelenFatura.PnrNo = null
      this.SatirGelenFatura.KDVYuzde = 0
      this.SatirGelenFatura.Tutar = 0
      this.SatirGelenFatura.KDVTutar = 0
      this.SatirGelenFatura.KDVliTutar = 0
      this.SatirGelenFatura.TevkifatTutar = 0
      this.SatirGelenFatura.TevkifatOran = 0
      this.SatirGelenFatura.StopajTutar = 0
      this.SatirGelenFatura.StopajOran = 0
      this.SatirGelenFatura.MatrahToplam = 0
      this.SatirGelenFatura.TutarToplam = 0
      this.SatirGelenFatura.KDVToplam = 0
      this.SatirGelenFatura.TevkifatToplam = 0
    } else {
      this.text1 = this.$t('Enter-Seller-Code')
      this.snackbar = true
    }
  }

  function satirkaydet() {
    var durum = false
    this.secilenkayitlar.forEach(element => {

      if (element.KalemMaliyet == 0) {
        durum = true
      }

    });

    if (durum == false) {
      this.maliyetegoreOranla();
    } else {
      this.esitOranla();
    }

    this.secilenkayitlar.forEach(element => {

      var kayit = {
        KDVYuzde: element.KDVYuzde,
        Tutar: element.Tutar,
        KDVliTutar: this.roundNumber(element.KDVliTutar, 2),
        KDVTutar: this.roundNumber(element.KDVTutar, 2),
        PNR_No: Number(element.PnrNo),
        TevkifatOran: element.TevkifatOran,
        TevkifatTutar: this.roundNumber(element.TevkifatTutar, 2),
        StopajOran: element.StopajOran,
        StopajTutar: this.roundNumber(element.StopajTutar, 2),
        IslemRef: element.IslemRef
      }

      this.GelenFatura.Fatura.Kalemler.push(kayit);
    });

    this.satirdialog = false
    this.diptopla();
  }




  //kaydetme işlemi
  function Kaydet(tip) {


    if (this.$refs.formgelenfatura.validate()) {



      if (this.GelenFatura.Fatura.Satici.kod != null) {


        if (this.GelenFatura.Fatura.Kalemler.length > 0) {

          this.loadingdialog = true
          this.GelenFatura.KayitTipi = tip
          this.GelenFatura.Fatura.ETTN = this.uuid;
          
          this.GelenFatura.Fatura.SaticiKod = this.GelenFatura.Fatura.Satici.kod
          let params = this.GelenFatura
          tool.http_post(this, 'GelenFaturaKaydet', params).then(
            response => {
              this.loadingdialog = false

              if (response.body.Status == true) {
                this.text1 = 'Kayıt işlemi tamamlandı'
                this.snackbar = true


                this.git(response.body.data)
                this.GelenFatura.Fatura = response.body.data

                if (tip == '1') {

                  this.GelenFatura.EskiFatura.SaticiTip = response.body.data.SaticiTip
                  this.GelenFatura.EskiFatura.SaticiKod = response.body.data.SaticiKod
                  this.GelenFatura.EskiFatura.FatSeri = response.body.data.FatSeri
                  this.GelenFatura.EskiFatura.FatNo = response.body.data.FatNo
                  this.GelenFatura.EskiFatura.FatTarih = this.GelenFatura.Fatura.FatTarih
                }




                this.GelenFatura.KayitTipi = 2
                this.islemtipi = 1
                this.guncellebuton = true
                this.kaydetbuton = false


              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true

              }
            },


            response => {
              this.text1 = 'Hata Oluştu, tekrar deneyiniz'
              this.snackbar = true
              this.loadingdialog = false
            }
          );

        } else {
          this.text1 = this.$t('Please-add-items')
          this.snackbar = true

        }

      } else {
        this.text1 = this.$t('Please-select-seller')
        this.snackbar = true

      }
    } else {

      this.text1 = this.$t('Please-fill-required-fields');
      this.snackbar = true

    }

  }




  function faturasil() {

    this.$refs.onaydialog.open('Bu faturayı silmek istediğinize emin misiniz?', 1).then(
      sonuc => {          
        if (sonuc == true) {
          let params = {
            SaticiTip: this.GelenFatura.Fatura.SaticiTip,
            SaticiKod: this.GelenFatura.Fatura.SaticiKod,
            FatSeri: this.GelenFatura.Fatura.FatSeri,
            FatNo: this.$route.query.fn,
            FatTarih: this.GelenFatura.Fatura.FatTarih
          }

          tool.http_post(this, 'GelenFaturaSil', params).then(

            response => {

              if (response.body.Status == true) {


                this.text1 = 'Faturanız silindi.'
                this.snackbar = true

                var url = '#/coper/page/formlar/gelenfaturalistesi'
                setTimeout(function () {
                  window.open(url, '_self')
                }.bind(this), 6000)


              } else {

                this.text1 = response.body.ErrorList[0]
                this.snackbar = true

              }

            },

            response => {

              this.text1 = 'Hata Oluştu, tekrar deneyiniz'

              this.snackbar = true

            }

          );



        }
      });





  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function iskontooranhesapla() {
    var params1 = {
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoTutar: this.SerbestFaturaDetay.IskontoTutar
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountRate', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoOran
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function iskontohesapla() {


    var params1 = {
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoOran: this.SerbestFaturaDetay.IskontoYuzde
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoTutar
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function kdvhesapla() {

    var params1 = {
      KdvTip: this.SerbestFaturaDetay.KdvTip,
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
      KdvOran: this.SerbestFaturaDetay.KdvYuzde
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetTaxAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.KdvTutar = response.body.KdvTutar
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Kdv Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Kdv Hesapla'
        this.snackbar = true
      }
    })
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }

  function carigetir(v) {

    this.statecari = []

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (v.length >= 2) {
      this.loading = true
      var query = {
        q: v,
        c: credentials.SirketKodu,
      }
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', query, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
        }, (response) => {
            if (response.status === 0) {
               this.text1 = 'Service Unavailable'
               this.snackbar = true
           } else {
               this.text1 = 'Service Unavailable'
               this.snackbar = true
           }
        })
        this.loading = false
      }, 750)
    }
  }

  function beforeMount() {


  }


  function earsivbilgigir() {
    this.dialogearsiv = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    //web adreslerini çekelim
    var params = {
      CompanyCode: credentials.SirketKodu,
      Type: '305'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.webadresleri = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-web adresleri'
        this.snackbar = true
      } else {

        this.text1 = 'Service Unavailable-web adresleri'
        this.snackbar = true
      }
    })


    //ödeme şekillerini çekelim
    var paramsGeneralTypeList = {
      CompanyCode: credentials.SirketKodu,
      Type: '306'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', paramsGeneralTypeList, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.odemesekilleri = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-ödeme şekli'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-ödeme şekli'
        this.snackbar = true
      }
    })
    // ödeme araçlarını alalalım
    var paramsGeneralTypeListv2 = {
      CompanyCode: credentials.SirketKodu,
      Type: '307'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', paramsGeneralTypeListv2, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.odemearaci = response.body
    }, (response) => {
      if (response.status === 0) {

        this.text1 = 'Service Unavailable-ödeme aracı'
        this.snackbar = true
      } else {

        this.text1 = 'Service Unavailable-ödeme aracı'
        this.snackbar = true
      }
    })



  }

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function ekle() {

    this.Current.Contract.ContractDate = this.SerbestFatura.Tarih

    var current = this.Current
    this.$http.post(auth.API_URL + 'api/Current/New', current, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status === true) {
        this.text1 = 'Kayıt Eklendi'
        this.snackbar = true
      } else if (response.body.Status === false) {
        this.text1 = 'Hata Oluştu'
        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        let data ={
        response: response,
        request: current,
        api:'Current/New',
        type:2,
        message: response.body.ExceptionMessage
        };
        this.$refs.showMessage.open(data);
      }
    })
  }

  function guncelle() {

    this.$validator.validateAll().then((result) => {
      if (result) {

        this.Current.Contract.ContractDate = this.SerbestFatura.Tarih
        var current = this.Current
        this.$http.post(auth.API_URL + 'api/Current/Update', current, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status === true) {
            this.text1 =this.$t('Record-Updated')
            this.snackbar = true
          } else if (response.body.Status === false) {
            this.text1 = 'Hata Oluştu'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
  .outer {

    position: relative;
    display: inline-block;
    margin: 0 10px;
    padding-top: inherit+100px;

  }

  .inner {
    position: absolute;
    top: 104%;
    left: 50%;
    padding-block-start: 30px;
    padding-block-end: 10px;
  }

  .icorta {
    margin: 0px auto;
    height: 226px;
    color: #fff;
    position: absolute;
    left: 92%;
    top: 95%;
    margin-left: -110px;
    margin-top: -15px;
  }

  .rotate {
    -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);

  }
</style>